(function () {
  var productPage = $("#product-page");
  var productObj = WS.ui.productObj || {}; // 商品全部数据
  var productDataDom = $('#product-page').find(".js-product-json");
  var productId = $('#product-page').attr('data-product-id');
  var selectedColor = "";
  var selectedSize = "";
  var selectedSku = "";
  var sizeFeedbackTimer = null;
  var cartFeedbackTimer = null;

  function setSizeFeedback(message) {
    var feedback = document.getElementById('ws-product-size-feedback');
    if (!feedback) return;
    window.clearTimeout(sizeFeedbackTimer);
    feedback.textContent = '';
    if (message) {
      sizeFeedbackTimer = window.setTimeout(function() {
        feedback.textContent = String(message);
      }, 20);
    }
  }

  function announceCartResult(message, isError) {
    var status = document.getElementById('ws-product-cart-status');
    var error = document.getElementById('ws-product-cart-error');
    if (!status || !error) return;
    window.clearTimeout(cartFeedbackTimer);
    status.textContent = '';
    error.textContent = '';
    if (message) {
      cartFeedbackTimer = window.setTimeout(function() {
        (isError ? error : status).textContent = String(message);
      }, 20);
    }
  }

  function setAddToBagSoldOut(soldOut) {
    $('#add-to-bag').toggleClass('sold-out', !!soldOut).attr('aria-disabled', soldOut ? 'true' : 'false');
  }
  var mediaSlider = null;
  var previewSlider = null;
  // also love相关参数
  var count = 20; // 每页请求数量，默认值10，最大值2000
  var lastId = ''; // 每页请求的最后Id
  var bottomCollectionId = '';  // 容错处理所需要的集合链接id
  var alsoLoveDom = $('#ws-product-alsolove');
  var country = WS.site.country;
  var countryInfo = WS.ui.countryInfoMap[country];
  var selectedShippingCountry = country;
  // 商品详情社媒数据保存在模块变量里，避免 Zepto .data() 序列化对象后弹窗取不到完整字段。
  var productSocialMediaItems = [];
  var completeLookScrollTimer = null;
  var completeLookIdleTimer = null;
  var completeLookCloseTimer = null;
  var completeLookIdleCleanup = null;

  // 100% Merino Wool ：1、 100% Linen： 2、**% Linen 、**%Cotton（Linen与Cotton混合成分）： 3、**% Linen 、**%Tencel （天丝）即Linen与Tencel （天丝）混合成分：4、 100% Wool：5
  var safeShopTabList = [
    {
      key: 'shipping',
      tabIcon: 'https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-shipping-package.svg',
      tabLabel: WS.$t('product.popup_shippiing.title')
    },
    {
      key: 'returns',
      tabIcon: 'https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-return-package.svg',
      tabLabel: WS.$t('product.popup_free_return.title')
    },
    {
      key: 'security',
      tabIcon: 'https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security.svg',
      tabLabel: WS.$t('product.popup_shop_security.title')
    }
  ];

  var sliderImageItemHtml = `
    <div class="slide-item ws-slide-ratio-3-4 js-lazyload-img" data-media-type="<%= data.mediaType %>" data-id="<%= data.id %>" data-index="<%= data.index %>">
      <img class="slide-item_image" data-lazyload-src="<%= data.url %>">
    </div>
  `;

  var sliderVideoItemHtml = `
    <div class="slide-item ws-slide-ratio-3-4 js-lazyload-img slide-video-item" data-media-type="<%= data.mediaType %>" data-id="<%= data.id %>" data-index="<%= data.index %>">
      <img class="slide-item_image" data-lazyload-src="<%= data.url %>">
      <img class="slide-item_video-btn video-play" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-play.png?v=1775619864">
      <img class="slide-item_video-btn video-pause" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_stop_3x_5492efa6-9c06-4952-b5db-404a72935c4b.png?v=1682660964">
      <video class="slide-item_video video-container" webkit-playsinline="true" playsinline="true">
        <source src="<%= data.videoUrl %>" type="video/mp4">
      </video>
    </div>
  `;
  
  var previewDialog = `
    <div class="product-preview_dialog" id="prodcut-preview_dialog">
      <div class="product-preview_close-wrapper">
          <img class="product-preview_close" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_previewImage_close.png?v=1638951402" />
        </div>
      <div class="product-preview_mask"></div>                  
      <div class="product-preview_wrapper">
        <div class="product-preview_container"></div>
      </div>
    </div>
  `;
  // shipping模块html
  var shippingContent = `
    <div class="model-shipping-wrapper">
      <div class="model-shipping-content">
        <!--<div class="i18n-lang-module i18n-lang-module-custom" data-key="${country}">
          <div class="i18n-lang-module_selector switch-country-btn" data-custom="self">
            <p class="i18n-lang-module_selector-label">Shipping to the</p>
            <p class="i18n-lang-module_selector-text"><%= data.curCountry %></p>
            <i class="i18n-lang-module_selector-arrow iconfont icon-select-arrow-down"></i>
          </div>
        </div>
        <div class="model-shipping_detaiws-item standard">
          <div class="model-shipping_detaiws-wrapper">
            <p class="model-shipping_detaiws-label">${ WS.$t('product.popup_shipping.title_standard') }</p>    
          </div>
          <div class="model-shipping_info-wrapper">
            <div class="model-shipping_info-item">
              <p class="model-shipping_info-label">${ WS.$t('product.popup_shipping.label_cost') }</p>
              <p class="model-shipping_info-text"><%= data.standardFreeText %></p>
            </div>
            <div class="model-shipping_info-item">
              <p class="model-shipping_info-label">${ WS.$t('product.popup_shipping.label_shipping_time') }</p>
              <p class="model-shipping_info-text"><%= data.standardShippingTime %></p>
            </div>
          </div>
        </div>
        <% if ( data.expressFreeText ) { %>
          <div class="model-shipping_detaiws-item express">
            <div class="model-shipping_detaiws-wrapper">
              <p class="model-shipping_detaiws-label">${ WS.$t('product.popup_shipping.title_express') }</p>    
              <p class="model-shipping_detaiws-sub-label">${ WS.$t('product.popup_shipping.tip') }</p>   
            </div> 
            <div class="model-shipping_info-wrapper">
              <div class="model-shipping_info-item">
                <p class="model-shipping_info-label">${ WS.$t('product.popup_shipping.label_cost') }</p>
                <p class="model-shipping_info-text"><%= data.expressFreeText %></p>
              </div>
              <div class="model-shipping_info-item">
                <p class="model-shipping_info-label">${ WS.$t('product.popup_shipping.label_shipping_time') }</p>
                <p class="model-shipping_info-text"><%= data.expressShippingTime %></p>
              </div>
            </div> 
          </div>
        <% } %>-->

        <div class="model-shipping-introduction">
          <p class="p1 title"><%t('product.popup_shipping.text_receiving_time') %></p>
          <p class="p1 subtitle">Order Processing</p>
          <p class="p4">Orders are processed within <span class="text-strong">1–3 business days.</span></p>
          <ul class="popupbox-inner_safe-shop-list mr-b20">
            <li>
              <p class="p4"><span class="text-strong">Mon – Thu (before 3 PM PST):</span> processed within 1–3 business days</p>
            </li>
            <li>
              <p class="p4"><span class="text-strong">Fri – Sun:</span> processed on the following Monday</p>
            </li>
            <li>
              <p class="p4"><span class="text-strong">Holidays excluded</span></p>
            </li>
          </ul>
          <p class="p1 subtitle">Delivery Time</p>
          <p class="p4">Estimated delivery:  <span class="text-strong">2–12 business days</span></p>

          <!--<p class="p2"><%t('product.popup_shipping.info_receiving_time') %></p>-->
          <p class="p3 fix-padding-bot"><a href="<%= data.baseUrl %>/pages/shipping-delivery-1"><%t('product.popup_shipping.btn_shipping_policy') %></a></p>
        </div>
      </div>
    </div>
  `;
  // return-refund模块html
  var returnRefundContent = `
    <div class="con-model-return-refund">
      <p class="p4 mr-b20">We want you to love your order. If something is not right, here is how we can help.</p>
      <p class="p4 mr-b10"><span class="text-strong"><%t('product.popup_free_return.label_return_notes') %></span></p>
      <ul class="popupbox-inner_safe-shop-list mr-b20">
        <li>
          <p class="p4">Free returns within <span class="text-strong">14 days of delivery</span></p>
        </li>
        <li>
          <p class="p4"><span class="text-strong">U.S. orders:</span> free return shipping</p>
        </li>
        <li>
          <p class="p4"><span class="text-strong">International orders:</span> return shipping is the customer's responsibility</p>
        </li>
        <li>
          <p class="p4"><span class="text-strong">No restocking fee</span></p>
        </li>
      </ul>

      <p class="p4 mr-b10"><span class="text-strong">Exchanges</span></p>
      <ul class="popupbox-inner_safe-shop-list mr-b20">
        <li>
          <p class="p4">Free exchange within <span class="text-strong">14 days of delivery</span></p>
        </li>
        <li>
          <p class="p4"><span class="text-strong">No restocking fee</span></p>
        </li>
      </ul>

      <p class="p4 mr-b20">Items marked 'Final Sale' are not eligible for returns or exchanges.</p>

      <p class="p3 fix-padding-bot"><a href="<%= data.baseUrl %>/pages/returns"><%t('product.popup_free_return.btn_return_policy') %></a></p>

      
      <!--<p class="p3"><%t('product.popup_free_return.text_return_notes_1') %>
        <% if (data.productFlashSaleStatus) { %>
          <span class="sp1"><%t('product.popup_free_return.text_flash_sale') %></span>
        <% } %>
      </p>
      <p class="p3">Grae Cove will honor one free returns process for each unique order. Just contact us within 30 days of receiving your order.</p>
      <p class="p3">Note: Items marked FINAL SALE cannot be returned or exchanged.</p>
      <p class="p3"><%t('product.popup_free_return.text_return_notes_3') %></p>
      <p class="p3"><%t('product.popup_free_return.text_return_notes_4') %></p>
      <p class="p4 fix-padding-bot"><a href="<%= data.baseUrl %>/pages/returns"><%t('product.popup_free_return.btn_return_policy') %></a></p>
      -->
    </div>
  `;
  // shopping-security安心购模块
  var shoppingSecurityContent = `
    <div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security2.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_quality')}</p>
        <p class="p2">${WS.$t('product.popup_shop_security.text_quality')}</p>
      </div>
    </div>
    <div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security3.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_safe_secure_payments')}</p>
        <div class="con-payment-icon">
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-shpopay.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-visa.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-payple.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-mastercard.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-apple.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-googlepay.png?v=1773661484" />
          <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-amex.png?v=1773661484" />
        </div>
      </div>
    </div>
    <div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security4.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_trackable_logistics')}</p>
        <p class="p2">${WS.$t('product.popup_shop_security.text_trackable_logistics')}</p>
      </div>
    </div>
    <!--<div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security5.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_money_back')}</p>
        <p class="p2">${WS.$t('product.popup_shop_security.text_money_back')}</p>
      </div>
    </div>-->
    <div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security6.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_helpful')}</p>
        <p class="p2">${WS.$t('product.popup_shop_security.text_helpful')}</p>
      </div>
    </div>
    <div class="model-shopping-security-box">
      <img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-security7.svg?v=1773661484" />
      <div class="info-box">
        <p class="p1">${WS.$t('product.popup_shop_security.label_privacy_protection')}</p>
        <p class="p2">${WS.$t('product.popup_shop_security.text_privacy_protection')}</p>
      </div>
    </div>
  `;
  // 安心购弹窗
  var safeShopPopup = `
    <div class="ws-main-popupbox popupbox_safe-shop">
      <div class="ws-main-popupbox-overlay"></div>
      <div class="ws-main-popupbox-con popupbox-container_safe-shop">
        <img class="popupbox-container_close-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" alt="close icon">
        <div class="safe-shop_tab-wrapper">
          <% for ( var [index, item] of data.entries() ) { %>
            <div class="safe-shop_tab-item" data-key="<%= item.key %>">
              <img class="safe-shop_tab-icon iconfont" src="<%= item.tabIcon %>"></img>
              <span class="safe-shop_tab-label"><%= item.tabLabel.toUpperCase() %></span>
            </div>  
          <% } %>
        </div>
        <div class="popupbox-inner_safe-shop"></div>
      </div>
    </div>
  `;      

  /**
   * Product Details 商品描述 Read more（仅此块；collection 等不传 WS.ui.makeTextReadMoreHtmlOpts 即为纯文本）。
   * 开启 HTML：① 将 expandAsHtml 改为 true  ② 或首调 productFn.initProductDetailsDescReadMore(true)
   * 无参 init 不重写 expandAsHtml（手风琴 / resize / onRecalc 可反复调用）。
   */
  var WS_PRODUCT_DETAILS_DESC_READ_MORE = {
    expandAsHtml: true,
    maxLines: 3,
    lineHeightFallbackMultiplier: 1.5,
    eventNamespace: 'wsProductDetailsDesc',
    resizeDelay: 180,
    fullTextAttr: 'data-full-text',
    sel: {
      block: '.js-product-details-desc',
      wrap: '.ws-product-details__desc__wrap',
      text: '.ws-product-details__desc-text',
      readMore: '.ws-product-details__desc__read-more',
      collapse: '.ws-product-details__desc__collapse',
      htmlSource: '.ws-product-details__desc-full-html'
    }
  };
  var WS_PRODUCT_DETAILS_DESC_READ_MORE_PC = {
    expandAsHtml: true,
    maxLines: 4,
    lineHeightFallbackMultiplier: 1.5,
    eventNamespace: 'wsProductDetailsDescPc',
    resizeDelay: 180,
    fullTextAttr: 'data-full-text',
    sel: {
      block: '.js-product-details-desc-pc',
      wrap: '.ws-product-details__desc__wrap',
      text: '.ws-product-details__desc-text',
      readMore: '.ws-product-details__desc__read-more',
      collapse: '.ws-product-details__desc__collapse',
      htmlSource: '.ws-product-details__desc-full-html'
    }
  };

  function wsEscapeHtml(text) {
    if (text == null) return '';
    var str = String(text);
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function wsNormalizeProductGid(rawId) {
    if (!rawId) return '';
    var s = String(rawId);
    if (s.indexOf('gid://shopify/Product/') === 0) return s;
    return 'gid://shopify/Product/' + s;
  }

  function wsProductDetailsDescReadMoreHtmlOpts(config) {
    if (!window.WS || !WS.ui || !WS.ui.makeTextReadMoreHtmlOpts) return {};
    var cfg = config || WS_PRODUCT_DETAILS_DESC_READ_MORE;
    return WS.ui.makeTextReadMoreHtmlOpts({
      sourceSelector: cfg.sel.htmlSource,
      when: function () {
        return cfg.expandAsHtml;
      }
    });
  }

  // 未选中尺码时：根据当前颜色下所有尺码的 LA Warehouse 库存，渲染默认 2 日达提示。
  function renderProductUsWarehouseStockTip() {
    if (!window.WS || !WS.ui || !WS.ui.renderUsWarehouseStockTip) return '';
    return WS.ui.renderUsWarehouseStockTip({
      scope: '#product-page',
      wrapperSelector: '#in-stock-wrapper',
      sizeSelector: '.product-page__size-item',
      syncShippingInfo: true
    });
  }

  // 已选中尺码时：只判断当前尺码是否支持 LA Warehouse 2 日达。
  function getProductSelectedUsWarehouseStockTipHtml(sizeItem) {
    if (!window.WS || !WS.ui || !WS.ui.formatSelectedUsWarehouseStockTipHtml) return '';
    return WS.ui.formatSelectedUsWarehouseStockTipHtml(sizeItem);
  }

  // 已选中尺码提示优先级：当前尺码 2 日达 > 当前 SKU 预售/低库存/pickup 旧逻辑。
  function renderProductSelectedSizeStockTip(sizeItem) {
    var tipStockHtml = getProductSelectedUsWarehouseStockTipHtml(sizeItem);
    if (tipStockHtml) {
      $('#ws-shipping-info').addClass('show');
    } else {
      tipStockHtml = WS.ui.formatVariantInStockTipHtml(sizeItem);
    }
    $('#in-stock-wrapper').html(tipStockHtml || '');
    return tipStockHtml;
  }

  function isProductUsWarehouseVariant(variant) {
    if (!variant) return false;
    var value = variant.is_us_warehouse;
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  function isProductUs2DayDeliveryEnabled(productData) {
    var value = productData && productData.enable_us_2_day_delivery;
    if (value == null || value === '') {
      value = $('#product-page').attr('data-enable-us-2-day-delivery');
    }
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  // 商品详情主图上的 2 日达标签：切换颜色后，按当前颜色所有尺码的 is_us_warehouse 实时更新文案。
  function getProductDetailDeliveryLabelText(productData, fallbackSizeItems) {
    if (!isProductUs2DayDeliveryEnabled(productData)) return '';
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    var totalVariantCount = variants.length;
    var usWarehouseCount = 0;
    var hasUsWarehouseField = false;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].is_us_warehouse != null) {
        hasUsWarehouseField = true;
      }
      if (isProductUsWarehouseVariant(variants[i])) {
        usWarehouseCount += 1;
      }
    }

    // 兜底：如果 JSON 里没有尺码仓库字段，则用当前颜色刚渲染出来的尺码 DOM 判断。
    if (!hasUsWarehouseField) {
      var $sizeItems = $(fallbackSizeItems || '.product-page__size-item');
      totalVariantCount = $sizeItems.length;
      usWarehouseCount = 0;
      $sizeItems.each(function() {
        var value = $(this).attr('data-is-us-warehouse');
        if (value === true || String(value || '').toLowerCase() === 'true') {
          usWarehouseCount += 1;
        }
      });
    }

    if (!totalVariantCount) return '';
    if (!usWarehouseCount) return '';
    return usWarehouseCount === totalVariantCount ? 'US 2-DAY' : 'SELECT US 2-DAY';
  }

  function renderProductDetailDeliveryLabelContent($label, labelText) {
    if (labelText === 'SELECT US 2-DAY') {
      $label.html('<span>SELECT</span><span>US 2-DAY</span>');
    } else {
      $label.text(labelText);
    }
  }

  function isProductCollectionMarketingActive(productData) {
    // 切色时优先读取目标商品状态；首次进入页面时回退到 Liquid 输出的状态。
    var value = productData && productData.collection_marketing_active;
    if (value == null || value === '') {
      value = $('#product-page').attr('data-collection-marketing-active');
    }
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  function updateProductDetailDeliveryLabel(productData) {
    var $slideBox = $('.slide-container-box').first();
    if (!$slideBox.length) return;

    var $label = $slideBox.find('.ws-product-detail-delivery-label').first();
    var $productPage = $('#product-page');
    var collectionMarketingActive = isProductCollectionMarketingActive(productData);
    var collectionMarketingLabel = String($productPage.attr('data-collection-marketing-label') || '').trim();

    // 集合活动标签占用同一位置且权重最高，切换颜色时不能被 2 日达逻辑覆盖。
    if (collectionMarketingActive && collectionMarketingLabel) {
      if (!$label.length) {
        $label = $('<div class="ws-product-detail-delivery-label ws-product-detail-campaign-label"></div>');
        var $campaignSlideNum = $slideBox.find('.slide-num-box').first();
        if ($campaignSlideNum.length) {
          $campaignSlideNum.after($label);
        } else {
          $slideBox.prepend($label);
        }
      }
      $label.addClass('ws-product-detail-campaign-label').text(collectionMarketingLabel);
      return;
    }

    var labelText = getProductDetailDeliveryLabelText(productData, '.product-page__size-item');
    if (!labelText) {
      $label.remove();
      return;
    }

    if (!$label.length) {
      $label = $('<div class="ws-product-detail-delivery-label"></div>');
      var $slideNum = $slideBox.find('.slide-num-box').first();
      if ($slideNum.length) {
        $slideNum.after($label);
      } else {
        $slideBox.prepend($label);
      }
    }

    $label.removeClass('ws-product-detail-campaign-label');
    renderProductDetailDeliveryLabelContent($label, labelText);
  }

  // 集合活动切换只维护 hidden；动态凑单文案仍由自身的 is-active 状态控制。
  function setProductMarketingElementHidden($element, hidden) {
    $element.prop('hidden', hidden).attr('aria-hidden', hidden ? 'true' : null);
  }

  function updateProductCollectionMarketingState(productData) {
    var $productPage = $('#product-page');
    if (!$productPage.length) return;

    var collectionMarketingActive = isProductCollectionMarketingActive(productData);
    var collectionMarketingUrl = String((productData && productData.collection_marketing_url) || '').trim();
    var $offer = $productPage.find('.product-collection-marketing-offer').first();
    var $message = $productPage.find('#product-campaign-message').first();
    var $activity = $productPage.find('.ws-product__basic-info-wrapper .activity-wrapper').first();

    $productPage.attr('data-collection-marketing-active', collectionMarketingActive ? 'true' : 'false');

    if (collectionMarketingActive && collectionMarketingUrl) {
      $offer.attr('href', collectionMarketingUrl);
    }

    // 集合营销命中时展示 SUMMER SALE；未命中时恢复普通活动文案。
    setProductMarketingElementHidden($offer, !collectionMarketingActive);
    setProductMarketingElementHidden($message, collectionMarketingActive);
    setProductMarketingElementHidden($activity, collectionMarketingActive);

    if (collectionMarketingActive) {
      $message.empty().removeClass('is-active');
    } else {
      productFn.renderProductCampaignMessage();
    }

    updateProductDetailDeliveryLabel(productData);
  }

  function wsSanitizeRichTextEl(el) {
    if (!el || el.nodeType !== 1) return;

    var ALLOWED = {
      A: true, P: true, BR: true, UL: true, OL: true, LI: true,
      STRONG: true, EM: true, B: true, I: true,
      H1: true, H2: true, H3: true, H4: true, H5: true, H6: true,
      BLOCKQUOTE: true, CODE: true, PRE: true,
      SPAN: true, DIV: true,
      IMG: true
    };

    function cleanAttrs(node) {
      if (!node || node.nodeType !== 1) return;
      var tag = node.tagName;
      // 仅清理 inline style（并移除 on* 事件属性以避免注入）。
      // 其余属性（class/id/data-* 等）全部保留，避免影响后台编辑器输出结构。
      Array.prototype.slice.call(node.attributes || []).forEach(function (attr) {
        var n = (attr && attr.name) ? String(attr.name).toLowerCase() : '';
        if (!n) return;
        if (n === 'style') { node.removeAttribute(attr.name); return; }
        if (n.indexOf('on') === 0) { node.removeAttribute(attr.name); return; }
      });

      if (tag === 'A') {
        var href = node.getAttribute('href') || '';
        // 阻止 javascript: 等危险协议
        if (/^\s*javascript:/i.test(href)) node.removeAttribute('href');
        var target = (node.getAttribute('target') || '').toLowerCase();
        if (target === '_blank') {
          var rel = node.getAttribute('rel') || '';
          if (!/\bnoopener\b/i.test(rel)) rel = (rel ? rel + ' ' : '') + 'noopener';
          if (!/\bnoreferrer\b/i.test(rel)) rel = (rel ? rel + ' ' : '') + 'noreferrer';
          node.setAttribute('rel', rel.trim());
        }
      }
    }

    function unwrap(node) {
      if (!node || !node.parentNode) return;
      while (node.firstChild) node.parentNode.insertBefore(node.firstChild, node);
      node.parentNode.removeChild(node);
    }

    // 用 TreeWalker 遍历 element 节点，避免边遍历边改导致遗漏
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_ELEMENT, null, false);
    var toProcess = [];
    var current = walker.currentNode;
    while (current) {
      toProcess.push(current);
      current = walker.nextNode();
    }

    toProcess.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;
      var tag = node.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') {
        node.parentNode && node.parentNode.removeChild(node);
        return;
      }
      if (!ALLOWED[tag]) {
        unwrap(node);
        return;
      }
      cleanAttrs(node);
    });
  }

  function wsSanitizeProductDetailsRichText() {
    try {
      var nodes = document.querySelectorAll('[data-ws-sanitize-html]');
      if (!nodes || !nodes.length) return;
      nodes.forEach(function (n) { wsSanitizeRichTextEl(n); });
    } catch (e) {}
  }

  // 商品详情页方法
  var productFn = {
    isDesktopView: function () {
      return typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 750px)').matches;
    },
    // PDP 价格区活动文案：只同步 #product-campaign-message，Complete The Look 另行优先复用 activity-wrapper。
    renderProductCampaignMessage: function () {
      var $message = $('#product-campaign-message');
      if (!$message.length) return;
      // 集合营销提醒权重最高，命中时不再展示购物车档位活动文案。
      if (isProductCollectionMarketingActive()) {
        $message.empty().removeClass('is-active');
        return;
      }
      var message = WS.ui && typeof WS.ui.getCampaignMessageByCartCount === 'function'
        ? WS.ui.getCampaignMessageByCartCount()
        : '';
      if (!message) {
        $message.empty().removeClass('is-active').hide();
        return;
      }
      $message.html(message).addClass('is-active').show();
    },
    // Complete The Look 标题下方文案：后台配置 activity-wrapper 时保持同文案；未配置时回退到购物车档位活动文案。
    renderCompleteLookCampaignMessage: function () {
      var $message = $('#complete-look-campaign-message');
      if (!$message.length) return;
      var $activity = $('.ws-product__basic-info-wrapper .activity-wrapper').first();
      var message = '';

      if ($activity.length && $.trim($activity.text())) {
        message = $activity.html();
      } else if (WS.ui && typeof WS.ui.getCampaignMessageByCartCount === 'function') {
        message = WS.ui.getCampaignMessageByCartCount();
      }

      if (!message) {
        $message.empty().removeClass('is-active').hide();
        return;
      }
      $message.html(message).addClass('is-active').show();
    },
    // PDP Free Gift 金额展示需要和购物车一致：符号 + 两位小数 + 当前币种代码。
    getCompleteLookFreeGiftCurrencyCode: function() {
      return (
        (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ||
        (document.documentElement && document.documentElement.getAttribute('currency')) ||
        (WS.site && WS.site.currency) ||
        'USD'
      ).toUpperCase();
    },
    // 将 cents 转成 PDP Free Gift 文案使用的金额格式，如 ¥0.00 CNY。
    formatCompleteLookFreeGiftAmount: function(cents) {
      var amount = Math.max(0, Number(cents) || 0) / 100;
      var amountText = amount.toFixed(2);
      var symbol = (WS.site && WS.site.symbol) || '$';
      var formattedAmount = WS.i18n && WS.i18n.fmtAmount ? WS.i18n.fmtAmount(amountText) : amountText;
      return symbol + formattedAmount + ' ' + productFn.getCompleteLookFreeGiftCurrencyCode();
    },
    // Free Gift 门槛固定按 400 USD；非 USD 不能把启动时兜底的 1.0 当作真实汇率。
    getCompleteLookFreeGiftThresholdCents: function(usdCents) {
      var thresholdUsdCents = Number(usdCents) || 40000;
      var currency = productFn.getCompleteLookFreeGiftCurrencyCode();
      var shopifyRate = typeof Shopify !== 'undefined' && Shopify.currency ? Number(Shopify.currency.rate) : 0;
      var siteRate = Number(WS.site && WS.site.rate);
      var converted = 0;

      if (currency === 'USD') return thresholdUsdCents;
      if (shopifyRate > 0 && shopifyRate !== 1) return Math.round(thresholdUsdCents * shopifyRate);

      if (typeof Currency !== 'undefined') {
        if (typeof Currency.convert === 'function') {
          converted = Number(Currency.convert(100, 'USD', currency));
          if (converted > 0 && converted !== 100) return Math.round(thresholdUsdCents * (converted / 100));
        } else if (Currency.rates && Currency.rates.USD && Currency.rates[currency]) {
          converted = Number(Currency.rates.USD) / Number(Currency.rates[currency]);
          if (converted > 0 && converted !== 1) return Math.round(thresholdUsdCents * converted);
        }
      }

      if (siteRate > 0 && siteRate !== 1) return Math.round(thresholdUsdCents * siteRate);
      return thresholdUsdCents;
    },
    // 根据 cart-data 派发的折扣后达标金额，刷新 PDP Free Gift 入口的三种状态文案。
    renderCompleteLookFreeGiftMessage: function(detail) {
      var $bars = $('.ws-complete-look-free-gift');
      if (!$bars.length) return;
      detail = detail || {};
      $bars.each(function() {
        var $bar = $(this);
        var thresholdUsdCents = Number(detail.freeGiftThresholdUsdCents || $bar.attr('data-free-gift-threshold-usd-cents') || $bar.attr('data-free-gift-threshold-cents') || 40000);
        var thresholdCents = Number(detail.freeGiftThresholdCents) || productFn.getCompleteLookFreeGiftThresholdCents(thresholdUsdCents);
        var subtotalCents = Number(
          detail.freeGiftEligibleSubtotalCents !== undefined
            ? detail.freeGiftEligibleSubtotalCents
            : $bar.attr('data-free-gift-subtotal-cents') || 0
        );
        var gapCents = thresholdCents - subtotalCents;
        var message = '';
        $bar.attr('data-free-gift-threshold-usd-cents', thresholdUsdCents);
        $bar.attr('data-free-gift-threshold-cents', thresholdCents);
        $bar.attr('data-free-gift-subtotal-cents', subtotalCents);
        if (subtotalCents <= 0) {
          message = 'Spend <strong>$400+ USD</strong> to redeem a free selected gift.';
        } else if (gapCents > 0) {
          message = 'Add <strong>' + productFn.formatCompleteLookFreeGiftAmount(gapCents) + '</strong> more to unlock your free gift.';
        } else {
          message = "You've unlocked 1 free selected gift.";
        }
        $bar.find('[data-complete-look-free-gift-message]').html(message);
      });
    },
    getCountryInfo: function(country) {
      var countryInfoMap = WS.ui.countryInfoMap;
      var countryInfoObj = countryInfoMap[country];
      if (!countryInfoObj) return {};
      var shippingCurrencySymbol = countryInfoObj.symbolCode + countryInfoObj.symbol;
      var standardFreeAmount = WS.i18n.fmtAmount(shippingCurrencySymbol + countryInfoObj.standard, country);
      var expressFreeAmount = WS.i18n.fmtAmount(shippingCurrencySymbol + countryInfoObj.express, country);
      var standardDay = countryInfoObj.standardDay;
      var expressDay = countryInfoObj.expressDay;
      var standardPostage = WS.i18n.fmtAmount(shippingCurrencySymbol + countryInfoObj.standardPostage, country);
      var expressPostage = WS.i18n.fmtAmount(shippingCurrencySymbol + countryInfoObj.expressPostage, country);
      var shippingData = {
        //  'UNITED STATES', 'CANADA', 'AUSTRALIA', 'UNITED KINGDOM', 'France', 'Germany', 'Spain', 'Italy'
        standardFreeText: standardPostage + ', ' + WS.$t('product.popup_shipping.text_standard_free', { amount: standardFreeAmount }),
        standardShippingTime: WS.$t('product.popup_shipping.text_shipping_time', { days: standardDay }),
        expressFreeText: '',
        baseUrl: WS.site.baseUrl,
        curCountry: WS.ui.countryInfoMap[selectedShippingCountry].name
      };
      if (standardFreeAmount !== expressFreeAmount) {
        shippingData.expressFreeText = expressPostage + ', ' + WS.$t('product.popup_shipping.text_express_free', { amount: expressFreeAmount });
        shippingData.expressShippingTime = WS.$t('product.popup_shipping.text_shipping_time', { days: expressDay });
      }
      return shippingData;
    },
    getProductDetailJson: function() {
      try {
        return JSON.parse($('#product-page').find(".js-product-detail-json").text() || 'null') || {};
      } catch (e) {
        return {};
      }
    },
    formatImageUrl: function(url, size, quality) {
      var returnUrl = WS.addParam({ width: size, quality: quality }, url);
      return returnUrl;
    },
    renderSliderByMedia: function(mediaList) {
      if (!Array.isArray(mediaList) || !mediaList.length) return;
      var sliderModuleDom = '';
      for (var i = 0; i < mediaList.length; i++) {
        var imgWidth = i === 0 ? 1176 : 700;
        var quality = i === 0 ? 90 : 85;
        var mediaItem = mediaList[i] || {};
        var previewImage = mediaItem.preview_image || {};
        var ratio = previewImage.aspect_ratio ? (1 / previewImage.aspect_ratio * 100) : 100;
        var url = productFn.formatImageUrl(previewImage.src || '', imgWidth, quality);
        var data = {
          mediaType: mediaItem.media_type || 'image',
          id: mediaItem.id || '',
          index: i,
          ratio: ratio,
          url: url,
          videoUrl: ''
        };
        if (data.mediaType === 'video' && Array.isArray(mediaItem.sources)) {
          for (var j = 0; j < mediaItem.sources.length; j++) {
            var sourceItem = mediaItem.sources[j] || {};
            if (sourceItem.url && sourceItem.url.indexOf('.mp4') > -1) {
              data.videoUrl = sourceItem.url;
              break;
            }
          }
        }
        var sliderTemplate = data.mediaType === 'video' ? sliderVideoItemHtml : sliderImageItemHtml;
        sliderModuleDom += WS.tmpl(sliderTemplate, data);
      }
      sliderModuleDom = `<div class="slide-container">${sliderModuleDom}</div>`;
      $('.slide-container-wrapper').html(sliderModuleDom);
      productFn.syncSlideSize();
      var $firstImg = $('.slide-container-wrapper').find('.slide-item_image').eq(0);
      if ($firstImg.length) {
        $firstImg.attr('id', 'westyle-image').addClass('js-image-onload-report');
        if (!$firstImg.attr('src') && $firstImg.attr('data-lazyload-src')) {
          $firstImg.attr('src', $firstImg.attr('data-lazyload-src'));
        }
      }
      setTimeout(function() {
        productFn.initSliderIndex();
        productFn.initSlide();
      }, 0);
    },
    showFreeReturnModule: function() {
      var countryData = productFn.getCountryInfo(country);
      var returnModuleTmpl = WS.tmpl(returnRefundContent, countryData);
      $('.popupbox-inner_safe-shop').html(returnModuleTmpl);
    },
    showShoppingSecurityModule: function() {
      $('.popupbox-inner_safe-shop').html(shoppingSecurityContent);
      if (!WS.ui.isFunctionOpenCountry()) {
        $('.popupbox-inner_safe-shop .payment-icon_klarna').hide();
      };
    },
    showShippingModule: function() {
      var countryData = productFn.getCountryInfo(selectedShippingCountry);
      var shippingModuleTmpl = WS.tmpl(shippingContent, countryData);
      $('.popupbox-inner_safe-shop').html(shippingModuleTmpl);
    },
    switchSafeShopModule: function(key) {
      switch (key) {
        case 'security':
           productFn.showShoppingSecurityModule();
           break;
        case 'shipping':
          productFn.showShippingModule();
          break;
        case 'returns':
          productFn.showFreeReturnModule();
          break;   
      }
    },
    closeSafeShopPopup: function() {
      var $p = $('.popupbox_safe-shop');
      if (!$p.length) return;
      WS.ui.i18nFn.removeSwitchCountryPopup && WS.ui.i18nFn.removeSwitchCountryPopup();
      if (productFn.isDesktopView() && $p.hasClass('popupbox_safe-shop--open')) {
        $p.removeClass('popupbox_safe-shop--open');
        setTimeout(function() {
          $p.remove();
        }, 320);
      } else {
        $p.remove();
      }
    },
    /**
     * 商品描述 Read more：测量 + 二分截断 + 展开/收起（对齐 collection）。
     * @param {boolean} [expandAsHtml] 仅 true/false 时同步写入移动端和 PC Description 配置；省略则保持原值。
     */
    initProductDetailsDescReadMore: function(expandAsHtml) {
      var configs = [WS_PRODUCT_DETAILS_DESC_READ_MORE, WS_PRODUCT_DETAILS_DESC_READ_MORE_PC];
      if (expandAsHtml === true || expandAsHtml === false) {
        configs.forEach(function(c) {
          c.expandAsHtml = expandAsHtml;
        });
      }
      if (!window.WS || !WS.ui || !WS.ui.initTextReadMore) return;
      configs.forEach(function(c) {
        var s = c.sel;
        // 已展开块在 resize 时跳过重算：见 westyle-ui.js initTextReadMore 内按块判断；
        // 点击 Less 时由 bindTextReadMoreEvents 设置 data-ws-readmore-force-collapse 强制该块重新截断
        WS.ui.initTextReadMore(
          $.extend(
            {
              blockSelector: s.block,
              wrapSelector: s.wrap,
              textSelector: s.text,
              readMoreSelector: s.readMore,
              collapseSelector: s.collapse,
              maxLines: c.maxLines,
              lineHeightFallbackMultiplier: c.lineHeightFallbackMultiplier,
              fullTextAttr: c.fullTextAttr
            },
            wsProductDetailsDescReadMoreHtmlOpts(c)
          )
        );
      });
    },
    /** 同 init 传参：同步修改移动端和 PC Description 的 expandAsHtml */
    setProductDetailsDescExpandAsHtml: function(on) {
      WS_PRODUCT_DETAILS_DESC_READ_MORE.expandAsHtml = on === true;
      WS_PRODUCT_DETAILS_DESC_READ_MORE_PC.expandAsHtml = on === true;
    },
    parseProductFaqsMeta: function(metaValue) {
      if (!metaValue) return [];
      var arr = [];
      try {
        arr = JSON.parse(metaValue);
      } catch (e) {
        return [];
      }
      if (!Array.isArray(arr)) return [];
      return arr
        .map(function(item) {
          return {
            question: item && item.question ? String(item.question).trim() : '',
            answer: item && item.answer ? String(item.answer).trim() : ''
          };
        })
        .filter(function(item) {
          return item.question && item.answer;
        });
    },
    renderProductFaqs: function(productTitle, faqList) {
      var $mount = $('#ws-product-faqs');
      if (!$mount.length) return;
      if (!Array.isArray(faqList) || !faqList.length) {
        $mount.empty().hide();
        return;
      }

      var safeTitle = wsEscapeHtml((productTitle || '').toUpperCase());
      var heading = 'Your Questions Answered';
      var html = '<section class="ws-product-faqs" aria-label="' + heading + '">';
      html += '<h2 class="ws-product-faqs__title">' + heading + '</h2>';
      if (safeTitle) {
        html += '<p class="ws-product-faqs__product-name">' + safeTitle + '</p>';
      }
      html += '<div class="ws-product-faqs__list">';
      for (var i = 0; i < faqList.length; i++) {
        var q = wsEscapeHtml(faqList[i].question);
        var a = wsEscapeHtml(faqList[i].answer).replace(/\n/g, '<br>');
        var isOpen = false;
        html += '<article class="ws-product-faqs__item clickable' + (isOpen ? ' is-open' : '') + '">';
        html +=   '<button type="button" class="ws-product-faqs__question ws-menu-toggle-btn" aria-expanded="' + (isOpen ? 'true' : 'false') + '">';
        html +=     '<span class="ws-product-faqs__question-text">' + q + '</span>';
        html +=     '<span class="ws-product-faqs__icon" aria-hidden="true">';
        html +=       '<span class="menu-icon menu-icon--plus"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-plus.png" alt=""></span>';
        html +=       '<span class="menu-icon menu-icon--minus"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-minus.png" alt=""></span>';
        html +=     '</span>';
        html +=   '</button>';
        html +=   '<div class="ws-product-faqs__answer">';
        html +=     '<p>' + a + '</p>';
        html +=   '</div>';
        html += '</article>';
      }
      html += '</div></section>';
      $mount.html(html).show();
    },
    // 商品详情社媒数据来自 metafield，字段名可能有大小写差异，这里统一兜底读取。
    getProductSocialField: function(item, keys) {
      if (!item || !keys || !keys.length) return '';
      for (var i = 0; i < keys.length; i++) {
        var value = item[keys[i]];
        if (value && typeof value === 'object' && value.value != null) value = value.value;
        if (value != null && value !== '') return value;
      }
      return '';
    },
    // 解析当前商品 social_media_list，并过滤不展示或没有媒体资源的条目。
    parseProductSocialMediaMeta: function(metaValue) {
      if (!metaValue) return [];
      var arr = metaValue;
      if (typeof arr === 'string') {
        try {
          arr = JSON.parse(arr);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(arr)) return [];
      return arr.filter(function(item) {
        if (!item) return false;
        var moduleDisplay = productFn.getProductSocialField(item, ['moduledisplay', 'moduleDisplay']);
        if (moduleDisplay !== '' && String(moduleDisplay).trim() !== '1') return false;
        var postCover = productFn.getProductSocialField(item, ['postcover', 'postCover']);
        var postMedia = productFn.getProductSocialField(item, ['postmedia', 'postMedia']);
        return !!(postCover || productFn.normalizeProductSocialMedia(postMedia).length);
      });
    },
    // postMedia 可能是数组、JSON 字符串或逗号分隔字符串，统一成 URL 数组。
    normalizeProductSocialMedia: function(mediaValue) {
      if (Array.isArray(mediaValue)) {
        return mediaValue.map(function(url) {
          return url == null ? '' : String(url).trim();
        }).filter(Boolean);
      }
      if (mediaValue && typeof mediaValue === 'object' && mediaValue.value != null) {
        mediaValue = mediaValue.value;
      }
      var mediaString = mediaValue == null ? '' : String(mediaValue).trim();
      if (!mediaString) return [];
      if (mediaString.charAt(0) === '[') {
        try {
          return productFn.normalizeProductSocialMedia(JSON.parse(mediaString));
        } catch (e) {}
      }
      return mediaString.split(',').map(function(url) {
        return String(url || '').trim();
      }).filter(Boolean);
    },
    isProductSocialMediaVideo: function(url) {
      var mediaUrl = String(url || '').toLowerCase();
      return mediaUrl.indexOf('.mp4') > -1 || mediaUrl.indexOf('.mov') > -1 || mediaUrl.indexOf('.m4v') > -1 || mediaUrl.indexOf('.webm') > -1;
    },
    // 视频来源可能只标 postType，也可能只体现在 reel 链接或 mp4 地址里。
    isProductSocialVideo: function(item) {
      var postType = productFn.getProductSocialField(item, ['posttype', 'postType']);
      var postTypeString = String(postType || '').trim().toLowerCase();
      var postUrl = String(productFn.getProductSocialField(item, ['posturl', 'postUrl']) || '');
      var mediaList = productFn.normalizeProductSocialMedia(productFn.getProductSocialField(item, ['postmedia', 'postMedia']));
      return postType === 2 || postTypeString === '2' || postTypeString.indexOf('video') > -1 || postUrl.indexOf('/reel/') > -1 || mediaList.some(function(url) {
        return String(url || '').toLowerCase().indexOf('.mp4') > -1;
      });
    },
    // 列表卡片优先展示 postCover，缺失时回退到第一条 postMedia。
    getProductSocialPrimaryMedia: function(item) {
      var postCover = String(productFn.getProductSocialField(item, ['postcover', 'postCover']) || '').trim();
      var mediaList = productFn.normalizeProductSocialMedia(productFn.getProductSocialField(item, ['postmedia', 'postMedia']));
      return postCover || mediaList[0] || '';
    },
    isProductSocialPopupVideoMode: function(item) {
      var postType = productFn.getProductSocialField(item, ['posttype', 'postType']);
      var postTypeString = String(postType || '').trim().toLowerCase();
      var postUrl = String(productFn.getProductSocialField(item, ['posturl', 'postUrl']) || '');
      return postType === 2 || postTypeString === '2' || postTypeString.indexOf('video') > -1 || postUrl.indexOf('/reel/') > -1;
    },
    // 后台返回的 ownerUsername 可能自带 @，这里统一输出展示格式。
    getProductSocialDisplayName: function(item) {
      var name = String(productFn.getProductSocialField(item, ['ownerUsername', 'ownerusername', 'owner_username']) || '').trim();
      if (!name) return '';
      return name.indexOf('@') > -1 ? name : '@' + name;
    },
    getProductSocialPostId: function(item) {
      return String(productFn.getProductSocialField(item, ['postid', 'postId', 'post_id', 'id', 'sort', 'posturl', 'postUrl']) || '').trim();
    },
    getProductSocialPlatform: function(item) {
      var source = String(productFn.getProductSocialField(item, ['postsource', 'postSource']) || '').trim().toLowerCase();
      var postUrl = String(productFn.getProductSocialField(item, ['posturl', 'postUrl']) || '').trim().toLowerCase();
      if (source === 'instagram') return 'ins';
      if (source) return source;
      if (postUrl.indexOf('instagram.com') > -1) return 'ins';
      if (postUrl.indexOf('facebook.com') > -1) return 'facebook';
      if (postUrl.indexOf('twitter.com') > -1 || postUrl.indexOf('x.com') > -1) return 'x';
      return '';
    },
    getProductSocialTrackAttrs: function(item, index) {
      return ' data-social-post-id="' + wsEscapeHtml(productFn.getProductSocialPostId(item)) + '"' +
        ' data-social-platform="' + wsEscapeHtml(productFn.getProductSocialPlatform(item)) + '"' +
        ' data-social-pos="' + (index + 1) + '"';
    },
    // 图标地址由 Liquid 输出到 mount 节点，JS 只按 key 读取，便于主题 asset 走 CDN 地址。
    getProductSocialIconUrl: function(name) {
      var $mount = $('#ws-product-social-media-mount');
      return $mount.attr('data-' + name + '-icon') || '';
    },
    // 图集弹窗需要包含封面图，同时避免 postCover 和 postMedia 第一张重复。
    getProductSocialGalleryList: function(item) {
      var postCover = String(productFn.getProductSocialField(item, ['postcover', 'postCover']) || '').trim();
      var mediaList = productFn.normalizeProductSocialMedia(productFn.getProductSocialField(item, ['postmedia', 'postMedia']));
      var list = [];
      if (postCover) list.push(postCover);
      mediaList.forEach(function(url) {
        if (url && url !== postCover) list.push(url);
      });
      return list;
    },
    // 渲染 Care Instructions 下方的 Spotted in NJ 模块。
    renderProductSocialMediaList: function(metaValue) {
      var $mount = $('#ws-product-social-media-mount');
      if (!$mount.length) return;
      var items = productFn.parseProductSocialMediaMeta(metaValue);
      if (!items.length) {
        productSocialMediaItems = [];
        $mount.empty().hide();
        return;
	      }
	      var html = '<section class="ws-product-social-media" aria-label="Spotted in NJ">';
	      html += '<h2 class="ws-product-social-media__title">Spotted in NJ</h2>';
	      var prevIcon = productFn.getProductSocialIconUrl('arrow-left');
	      var nextIcon = productFn.getProductSocialIconUrl('arrow-right');
	      // 复用全局轮播箭头组件；保留产品社媒原有类名供滚动与禁用态逻辑查询。
	      html += '<div class="ws-product-social-media__carousel ws-carousel-controls">';
	      html += '<button type="button" class="ws-product-social-media__arrow ws-product-social-media__arrow--prev ws-carousel-arrow is-disabled" aria-label="Previous" aria-disabled="true" disabled>';
	      if (prevIcon) html += '<img src="' + wsEscapeHtml(prevIcon) + '" alt="" loading="lazy">';
	      html += '</button>';
	      html += '<div class="ws-product-social-media__list-wrapper"><div class="ws-social-module__list">';
	      var visibleCount = 0;
	      items.forEach(function(item, index) {
	        var cardHtml = productFn.renderProductSocialCard(item, index);
	        if (cardHtml) {
	          html += cardHtml;
	          visibleCount++;
	        }
	      });
	      html += '</div></div>';
	      html += '<button type="button" class="ws-product-social-media__arrow ws-product-social-media__arrow--next ws-carousel-arrow is-disabled" aria-label="Next" aria-disabled="true" disabled>';
	      if (nextIcon) html += '<img src="' + wsEscapeHtml(nextIcon) + '" alt="" loading="lazy">';
	      html += '</button></div></section>';
	      if (!visibleCount) {
	        productSocialMediaItems = [];
	        $mount.empty().hide();
	        return;
	      }
	      productSocialMediaItems = items;
	      $mount.html(html).show();
	      productFn.initProductSocialCarousel($mount);
	      productFn.initProductSocialReport($mount);
	    },
	    initProductSocialReport: function(root) {
	      var $root = root ? $(root) : $(document);
	      $root.find('.ws-product-social-media .ws-social-module__card').each(function(index) {
	        var cardDom = this;
	        $(cardDom).attr('data-social-pos', index + 1);
	        if (cardDom.__wsSocialPostShowBound) return;
	        cardDom.__wsSocialPostShowBound = true;
	        var reportPostShow = function() {
	          if (cardDom.__wsSocialPostShowReported) return;
	          cardDom.__wsSocialPostShowReported = true;
	          WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_show', WS.ui.reportType['moduleShow'], cardDom, { includePosition: true });
	        };
	        if (WS.observe && WS.observe.intersection) {
	          WS.observe.intersection(cardDom, function(entries, observer) {
	            for (var i = 0, len = entries.length; i < len; i++) {
	              if (entries[i].isIntersecting) {
	                observer.unobserve(entries[i].target);
	                reportPostShow();
	              }
	            }
	          }, { threshold: [0.5] });
	        } else {
	          reportPostShow();
	        }
	      });
	    },
	    // 初始化商品详情社媒横向列表：绑定滚动同步、PC 拖拽和首屏箭头状态。
	    initProductSocialCarousel: function(root) {
	      var $root = root ? $(root) : $(document);
	      $root.find('.ws-product-social-media').each(function() {
	        var section = this;
	        var wrapper = $(section).find('.ws-product-social-media__list-wrapper').get(0);
	        if (!wrapper) return;
	        if (wrapper.__wsProductSocialScrollHandler) {
	          wrapper.removeEventListener('scroll', wrapper.__wsProductSocialScrollHandler);
	        }
	        wrapper.__wsProductSocialScrollHandler = function() {
	          if (wrapper.__wsProductSocialRaf) return;
	          var raf = window.requestAnimationFrame || function(cb) { return setTimeout(cb, 16); };
	          wrapper.__wsProductSocialRaf = raf(function() {
	            wrapper.__wsProductSocialRaf = null;
	            productFn.updateProductSocialCarouselArrows(section);
	          });
	        };
	        wrapper.addEventListener('scroll', wrapper.__wsProductSocialScrollHandler, { passive: true });
	        productFn.bindProductSocialCarouselDrag(wrapper);
	        productFn.updateProductSocialCarouselArrows(section);
	        setTimeout(function() {
	          productFn.updateProductSocialCarouselArrows(section);
	        }, 100);
	      });
	    },
	    // 按当前可视区域计算一次箭头点击需要滚动的距离，尽量按整屏卡片推进。
	    getProductSocialCarouselScrollStep: function(wrapper) {
	      if (!wrapper) return 0;
	      var $cards = $(wrapper).find('.ws-social-module__card');
	      var maxScroll = Math.max(0, (wrapper.scrollWidth || 0) - (wrapper.clientWidth || 0));
	      if (!$cards.length) return maxScroll;
	      var cardStep = $cards.length > 1
	        ? $cards[1].getBoundingClientRect().left - $cards[0].getBoundingClientRect().left
	        : $cards[0].getBoundingClientRect().width;
	      if (!cardStep || cardStep <= 0) cardStep = $cards[0].offsetWidth || wrapper.clientWidth || maxScroll;
	      var cardsPerView = Math.max(1, Math.floor((wrapper.clientWidth || cardStep) / cardStep));
	      return Math.min(maxScroll, Math.max(cardStep, cardStep * cardsPerView));
	    },
	    // 同步左右箭头状态：全部可见时隐藏，滚到边界时置灰并禁用。
	    updateProductSocialCarouselArrows: function(sectionDom) {
	      var $section = $(sectionDom);
	      var wrapper = $section.find('.ws-product-social-media__list-wrapper').get(0);
	      var $prev = $section.find('.ws-product-social-media__arrow--prev').first();
	      var $next = $section.find('.ws-product-social-media__arrow--next').first();
	      if (!wrapper || !$prev.length || !$next.length) return;

	      var scrollWidth = wrapper.scrollWidth || 0;
	      var clientWidth = wrapper.clientWidth || 0;
	      var scrollLeft = wrapper.scrollLeft || 0;
	      var epsilon = 2;
	      var hasOverflow = scrollWidth > clientWidth + epsilon;
	      var atStart = !hasOverflow || scrollLeft <= epsilon;
	      var atEnd = !hasOverflow || scrollLeft + clientWidth >= scrollWidth - epsilon;
	      $section.toggleClass('is-overflowing', hasOverflow).addClass('is-carousel-ready');
	      $prev.add($next).toggleClass('is-hidden', !hasOverflow);
	      $prev.prop('disabled', atStart).toggleClass('is-disabled', atStart).attr('aria-disabled', atStart ? 'true' : 'false');
	      $next.prop('disabled', atEnd).toggleClass('is-disabled', atEnd).attr('aria-disabled', atEnd ? 'true' : 'false');
	    },
	    // 左右箭头触发平滑横滑，滚动动画结束后补一次状态同步。
	    scrollProductSocialCarousel: function(sectionDom, direction) {
	      var $section = $(sectionDom);
	      var wrapper = $section.find('.ws-product-social-media__list-wrapper').get(0);
	      if (!wrapper || !direction) return;
	      var step = productFn.getProductSocialCarouselScrollStep(wrapper);
	      var maxScroll = Math.max(0, (wrapper.scrollWidth || 0) - (wrapper.clientWidth || 0));
	      var target = Math.max(0, Math.min(maxScroll, (wrapper.scrollLeft || 0) + step * direction));
	      if (typeof wrapper.scrollTo === 'function') {
	        try {
	          wrapper.scrollTo({ left: target, behavior: 'smooth' });
	        } catch (e) {
	          wrapper.scrollLeft = target;
	        }
	      } else {
	        wrapper.scrollLeft = target;
	      }
	      productFn.updateProductSocialCarouselArrows(sectionDom);
	      setTimeout(function() {
	        productFn.updateProductSocialCarouselArrows(sectionDom);
	      }, 450);
	    },
	    // PC 鼠标拖动横滑后会短暂拦截点击，避免拖完误开社媒详情弹窗。
	    bindProductSocialCarouselDrag: function(wrapper) {
	      if (!wrapper || wrapper.__wsProductSocialDragReady) return;
	      wrapper.__wsProductSocialDragReady = true;
	      var dragging = false;
	      var moved = false;
	      var startX = 0;
	      var startLeft = 0;
	      var endDrag = function() {
	        if (!dragging) return;
	        dragging = false;
	        wrapper.classList.remove('is-dragging');
	        if (moved) {
	          wrapper.__wsProductSocialSuppressClick = true;
	          setTimeout(function() {
	            wrapper.__wsProductSocialSuppressClick = false;
	          }, 160);
	        }
	        productFn.updateProductSocialCarouselArrows($(wrapper).closest('.ws-product-social-media').get(0));
	      };
	      wrapper.addEventListener('mousedown', function(e) {
	        if (e.button !== 0 || $(e.target).closest('button, a').length) return;
	        dragging = true;
	        moved = false;
	        startX = e.pageX;
	        startLeft = wrapper.scrollLeft || 0;
	        wrapper.classList.add('is-dragging');
	        e.preventDefault();
	      });
	      document.addEventListener('mousemove', function(e) {
	        if (!dragging) return;
	        var delta = e.pageX - startX;
	        if (Math.abs(delta) > 3) moved = true;
	        if (moved) e.preventDefault();
	        wrapper.scrollLeft = startLeft - delta;
	      });
	      document.addEventListener('mouseup', endDrag);
	      wrapper.addEventListener('mouseleave', endDrag);
	      wrapper.addEventListener('dragstart', function(e) {
	        e.preventDefault();
	      });
	    },
	    // 渲染商品详情页社媒卡片，图集/视频角标与首页社媒保持一致。
	    renderProductSocialCard: function(item, index) {
	      var primaryMedia = productFn.getProductSocialPrimaryMedia(item);
	      if (!primaryMedia) return '';
      var isVideo = productFn.isProductSocialVideo(item);
      var mediaList = productFn.getProductSocialGalleryList(item);
      var ownerName = productFn.getProductSocialDisplayName(item);
      var ownerImage = String(productFn.getProductSocialField(item, ['ownerImage', 'ownerimage', 'owner_image']) || '').trim();
      var postUrl = String(productFn.getProductSocialField(item, ['posturl', 'postUrl']) || '').trim();
      var typeIcon = '';
      if (isVideo) {
        typeIcon = productFn.getProductSocialIconUrl('play');
      } else if (mediaList.length > 1) {
        typeIcon = productFn.getProductSocialIconUrl('gallery');
      }

      var html = '<div class="ws-social-module__card" data-block-index="' + index + '"' + productFn.getProductSocialTrackAttrs(item, index) + ' data-blogger-name="' + wsEscapeHtml(ownerName) + '" data-product-url="' + wsEscapeHtml(postUrl) + '">';
      html += '<div class="ws-social-module__card-inner">';
	      html += '<div class="ws-social-module__card-media' + (isVideo ? ' ws-social-module__card-media--video' : '') + '">';
	      if (isVideo && !productFn.getProductSocialField(item, ['postcover', 'postCover'])) {
	        html += '<video class="ws-social-module__card-video" muted playsinline webkit-playsinline preload="metadata"><source src="' + wsEscapeHtml(primaryMedia) + '" type="video/mp4"></video>';
	      } else {
	        html += '<img class="ws-social-module__card-img" src="' + wsEscapeHtml(primaryMedia) + '" alt="" loading="lazy" draggable="false">';
	      }
      if (typeIcon) {
        html += '<span class="ws-social-module__type-icon" aria-hidden="true"><img src="' + wsEscapeHtml(typeIcon) + '" alt=""></span>';
      }
      if (ownerName) {
        html += '<p class="ws-social-module__card-blogger">';
        if (ownerImage) {
          html += '<span class="ws-social-module__card-blogger-avatar"><img src="' + wsEscapeHtml(ownerImage) + '" alt="" loading="lazy"></span>';
        }
        html += '<span>' + wsEscapeHtml(ownerName) + '</span></p>';
      }
      html += '</div></div></div>';
      return html;
    },
    // 打开商品详情社媒弹窗，并复用首页社媒的锁滚动和客服隐藏逻辑。
    openProductSocialPopup: function(index) {
      var item = productSocialMediaItems[index];
      if (!item) return;
      $('.ws-vertical-popupbox-product-social').remove();
      var html = '<div class="ws-vertical-popupbox ws-vertical-popupbox-social-module ws-vertical-popupbox-product-social"' + productFn.getProductSocialTrackAttrs(item, index) + '>';
      html += '<div class="ws-vertical-popupbox-overlay"></div>';
      html += '<div class="ws-social-module-popup"><div class="ws-social-module-popup__content-slot">';
      html += productFn.renderProductSocialPopup(item);
      html += '</div></div></div>';
      $('body').append(html);
      var $popup = $('.ws-vertical-popupbox-product-social').last();
      WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_pop', WS.ui.reportType['moduleShow'], $popup, { includePosition: true });
      WS.ui.initSocialPopupProductExposure && WS.ui.initSocialPopupProductExposure($popup);
      productFn.initProductSocialPopupGallery($popup);
      productFn.initProductSocialPopupDesc($popup);
      WS.ui.popupNoScrollHandle();
      WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
    },
    // 渲染弹窗内容区：博主信息、描述和当前商品卡片。
    renderProductSocialPopup: function(item) {
      var html = productFn.renderProductSocialPopupMedia(item);
      var ownerName = productFn.getProductSocialDisplayName(item);
      var ownerImage = String(productFn.getProductSocialField(item, ['ownerImage', 'ownerimage', 'owner_image']) || '').trim();
      var postContent = String(productFn.getProductSocialField(item, ['postcontent', 'postContent']) || '').trim();
      var postUrl = String(productFn.getProductSocialField(item, ['posturl', 'postUrl']) || '').trim();
      var hasMedia = !!productFn.getProductSocialPrimaryMedia(item);

      html += '<div class="ws-social-module-popup__content' + (hasMedia ? ' ws-social-module-popup__content--has-media' : '') + '">';
      html += '<button type="button" class="ws-social-module-popup__close ws-social-module-popup__close--content con-close-btn" aria-label="Close"><img src="' + wsEscapeHtml(productFn.getProductSocialIconUrl('close')) + '" alt=""></button>';
      if (ownerName || postContent) {
        html += postUrl ? '<a class="ws-social-module-popup__profile" href="' + wsEscapeHtml(postUrl) + '" target="_blank" rel="noopener">' : '<div class="ws-social-module-popup__profile">';
        if (ownerName || ownerImage) {
          html += '<div class="ws-social-module-popup__blogger">';
          if (ownerImage) html += '<span class="ws-social-module-popup__blogger-avatar"><img src="' + wsEscapeHtml(ownerImage) + '" alt="" loading="lazy"></span>';
          if (ownerName) html += '<span class="ws-social-module-popup__blogger-name">' + wsEscapeHtml(ownerName) + '</span>';
          html += '</div>';
        }
        if (postContent) {
          html += '<p class="ws-social-module-popup__desc js-social-module-popup-desc" data-full-text="' + wsEscapeHtml(postContent) + '">';
          html += '<span class="ws-social-module-popup__desc-wrap"><span class="ws-social-module-popup__desc-text" data-collapsed="true">' + wsEscapeHtml(postContent) + '</span><span class="ws-social-module-popup__desc-read-more" aria-expanded="false"> &gt;&gt;</span></span>';
          html += '<span class="ws-social-module-popup__desc-collapse" aria-expanded="true" style="display: none;"></span></p>';
        }
        html += postUrl ? '</a>' : '</div>';
      }
      html += productFn.renderProductSocialProductCard();
      html += '</div>';
      return html;
    },
    // 弹窗媒体区按 postType 渲染视频或图集，视频优先用 postCover 做封面。
    renderProductSocialPopupMedia: function(item) {
      var isVideo = productFn.isProductSocialPopupVideoMode(item);
      var galleryList = productFn.getProductSocialGalleryList(item);
      var videoList = productFn.normalizeProductSocialMedia(productFn.getProductSocialField(item, ['postmedia', 'postMedia']));
      var videoUrl = '';
      if (isVideo) {
        videoUrl = videoList.filter(function(url) {
          return productFn.isProductSocialMediaVideo(url);
        })[0] || videoList[0] || '';
      }
      var postCover = String(productFn.getProductSocialField(item, ['postcover', 'postCover']) || '').trim();
      var primaryMedia = productFn.getProductSocialPrimaryMedia(item);
      if (!videoUrl && !primaryMedia) return '';

      var html = '<div class="ws-social-module-popup__media';
      html += videoUrl ? ' ws-social-module-popup__video-wrap' : ' ws-social-module-popup__image-gallery' + (galleryList.length > 1 ? ' ws-social-module-popup__image-gallery--multiple' : '');
      html += '">';
      if (videoUrl) {
        html += '<video class="ws-social-module-popup__video" playsinline webkit-playsinline preload="metadata" poster="' + wsEscapeHtml(postCover) + '"><source src="' + wsEscapeHtml(videoUrl) + '" type="video/mp4"></video>';
        html += '<button type="button" class="ws-social-module-popup__play-btn" aria-label="Play"><img src="' + wsEscapeHtml(productFn.getProductSocialIconUrl('popup-play')) + '" alt=""></button>';
      } else {
        html += '<div class="ws-social-module-popup__image-track">';
        galleryList.forEach(function(url, index) {
          var isGalleryVideo = productFn.isProductSocialMediaVideo(url);
          html += '<div class="ws-social-module-popup__image-slide' + (isGalleryVideo ? ' ws-social-module-popup__image-slide--video' : '') + (index === 0 ? ' is-active' : '') + '" data-slide-index="' + index + '">';
          if (isGalleryVideo) {
            html += '<video class="ws-social-module-popup__video" playsinline webkit-playsinline preload="metadata" poster="' + wsEscapeHtml(postCover) + '"><source src="' + wsEscapeHtml(url) + '"></video>';
            html += '<button type="button" class="ws-social-module-popup__play-btn" aria-label="Play"><img src="' + wsEscapeHtml(productFn.getProductSocialIconUrl('popup-play')) + '" alt=""></button>';
          } else {
            html += '<img class="ws-social-module-popup__image" src="' + wsEscapeHtml(url) + '" alt="" loading="lazy" draggable="false">';
          }
          html += '</div>';
        });
        html += '</div>';
        if (galleryList.length > 1) {
          html += '<button type="button" class="ws-social-module-popup__gallery-arrow ws-social-module-popup__gallery-arrow--prev" aria-label="Previous image"></button>';
          html += '<button type="button" class="ws-social-module-popup__gallery-arrow ws-social-module-popup__gallery-arrow--next" aria-label="Next image"></button>';
          html += '<div class="ws-social-module-popup__gallery-dots" aria-label="Image pagination">';
          galleryList.forEach(function(url, index) {
            html += '<button type="button" class="ws-social-module-popup__gallery-dot' + (index === 0 ? ' is-active' : '') + '" data-slide-index="' + index + '" aria-label="Show image ' + (index + 1) + '"></button>';
          });
          html += '</div>';
        }
      }
      html += '<button type="button" class="ws-social-module-popup__close con-close-btn" aria-label="Close"><img src="' + wsEscapeHtml(productFn.getProductSocialIconUrl('close')) + '" alt=""></button>';
      html += '</div>';
      return html;
    },
    // 商品卡片只展示当前商品，图片取 preview_image，缺失时兜底到 images。
    getProductSocialProductImage: function(productInfo) {
      if (productInfo.preview_image && productInfo.preview_image.src) return productInfo.preview_image.src;
      var images = productInfo.images || [];
      for (var i = 0; i < images.length; i++) {
        var img = images[i] || {};
        if (img.preview_image && img.preview_image.src) return img.preview_image.src;
        if (img.src) return img.src;
        if (img.url) return img.url;
      }
      return '';
    },
    // 社媒弹窗商品价格不展示折扣价，只按当前商品价格格式化。
    formatProductSocialPrice: function(productInfo) {
      var price = productInfo.price || productInfo.defaultPrice || '';
      var formatted = WS.ui.formatPrice ? WS.ui.formatPrice(price) : '';
      if (!formatted && productInfo.price_code) formatted = String(productInfo.price_code) + ' ' + (WS.site.currency || 'USD');
      return formatted.replace(/^([^0-9\s-]+)/, '$1 ');
    },
    // 弹窗底部商品卡片：点击卡片跳商品详情，点击加购图标打开加购弹窗。
    renderProductSocialProductCard: function() {
      var productInfo = productFn.getProductDetailJson();
      if (!productInfo || !productInfo.id) return '';
      var imgUrl = productFn.getProductSocialProductImage(productInfo);
      var productUrl = productInfo.product_url || (productInfo.handle ? ((WS.site.dir || '') + '/products/' + productInfo.handle) : '#');
      var title = productInfo.title || '';
      var cartIcon = productFn.getProductSocialIconUrl('cart');
      var html = '<div class="ws-social-module-popup__products"><div class="ws-social-module-popup__products-track">';
      html += '<a href="' + wsEscapeHtml(productUrl) + '" class="ws-social-module-popup__product" target="_blank" rel="noopener" aria-label="' + wsEscapeHtml(title) + '" data-product-id="' + wsEscapeHtml(productInfo.id) + '">';
      html += '<div class="js-social-product-json" style="display: none;">' + wsEscapeHtml(JSON.stringify(productInfo)) + '</div>';
      if (imgUrl) html += '<img class="ws-social-module-popup__product-img" src="' + wsEscapeHtml(imgUrl) + '" alt="' + wsEscapeHtml(title) + '" loading="lazy">';
      html += '<div class="ws-social-module-popup__product-info"><p class="ws-social-module-popup__product-title">' + wsEscapeHtml(title) + '</p>';
      html += '<div class="ws-social-module-popup__product-bottom"><p class="ws-social-module-popup__product-price">' + wsEscapeHtml(productFn.formatProductSocialPrice(productInfo)) + '</p>';
      html += '<span class="ws-social-module-popup__product-action" role="button" tabindex="0" aria-label="Add ' + wsEscapeHtml(title) + ' to cart" data-product-id="' + wsEscapeHtml(productInfo.id) + '">';
      if (cartIcon) html += '<img src="' + wsEscapeHtml(cartIcon) + '" alt="">';
      html += '</span></div></div></a></div></div>';
      return html;
    },
    // 移动端描述最多两行并显示 ... >>；PC 端展示完整描述。
    initProductSocialPopupDesc: function(root) {
      if (!window.WS || !WS.ui || !WS.ui.initTextReadMore) return;
      var $root = root ? $(root) : $(document);
      var isDesktop = function() {
        return typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 750px)').matches;
      };
      var reset = function() {
        $root.find('.js-social-module-popup-desc').each(function() {
          var $desc = $(this);
          var fullText = $desc.attr('data-full-text') || '';
          $desc.find('.ws-social-module-popup__desc-text').text(fullText).attr('data-collapsed', 'false');
          $desc.find('.ws-social-module-popup__desc-read-more').hide().attr('aria-expanded', 'false');
          $desc.find('.ws-social-module-popup__desc-collapse').hide().attr('aria-expanded', 'false');
          $desc.find('.ws-social-module-popup__desc-wrap').removeAttr('data-ws-readmore-ready');
        });
      };
      var sync = function() {
        if (isDesktop()) {
          reset();
          return;
        }
        WS.ui.initTextReadMore({
          blockSelector: '.js-social-module-popup-desc',
          wrapSelector: '.ws-social-module-popup__desc-wrap',
          textSelector: '.ws-social-module-popup__desc-text',
          readMoreSelector: '.ws-social-module-popup__desc-read-more',
          collapseSelector: '.ws-social-module-popup__desc-collapse',
          maxLines: 2,
          lineHeightFallbackMultiplier: 1.16,
          fullTextAttr: 'data-full-text'
        });
      };
      sync();
      setTimeout(sync, 80);
      setTimeout(sync, 250);
    },
    // 同步弹窗图集当前页、指示点和左右箭头边界状态。
    syncProductSocialPopupGallery: function(galleryDom) {
      var $gallery = $(galleryDom);
      var $track = $gallery.find('.ws-social-module-popup__image-track').first();
      var $slides = $gallery.find('.ws-social-module-popup__image-slide');
      var $dots = $gallery.find('.ws-social-module-popup__gallery-dot');
      var $prev = $gallery.find('.ws-social-module-popup__gallery-arrow--prev');
      var $next = $gallery.find('.ws-social-module-popup__gallery-arrow--next');
      var track = $track.get(0);
      var count = $dots.length || $slides.length;
      if (!track || !count) return;
      var gallery = $gallery.get(0);
      var index = typeof gallery.__wsSocialGalleryIndex === 'number' ? gallery.__wsSocialGalleryIndex : parseInt($gallery.attr('data-active-index') || 0, 10);
      if (isNaN(index)) index = 0;
      index = Math.max(0, Math.min(index, count - 1));
      gallery.__wsSocialGalleryIndex = index;
      $gallery.attr('data-active-index', index);
      track.scrollLeft = (track.clientWidth || 0) * index;
      $slides.removeClass('is-active').filter('[data-slide-index="' + index + '"]').addClass('is-active');
      $slides.not('.is-active').find('.ws-social-module-popup__video').each(function() {
        this.pause();
      });
      $dots.removeClass('is-active').eq(index).addClass('is-active');
      $prev.toggleClass('is-disabled', index === 0).attr('aria-disabled', index === 0 ? 'true' : 'false');
      $next.toggleClass('is-disabled', index === count - 1).attr('aria-disabled', index === count - 1 ? 'true' : 'false');
    },
    // 弹窗图集只允许按钮/指示点切换，边界不循环。
    goToProductSocialPopupGallery: function(galleryDom, index) {
      var $gallery = $(galleryDom);
      var $track = $gallery.find('.ws-social-module-popup__image-track').first();
      var track = $track.get(0);
      var count = $gallery.find('.ws-social-module-popup__gallery-dot').length || $gallery.find('.ws-social-module-popup__image-slide').length;
      var gallery = $gallery.get(0);
      if (!track || !count) return;
      index = Math.max(0, Math.min(index, count - 1));
      gallery.__wsSocialGalleryIndex = index;
      track.scrollLeft = (track.clientWidth || 0) * index;
      productFn.syncProductSocialPopupGallery(gallery);
    },
    // 每次打开弹窗都从第一张媒体开始，并延迟再同步一次防止尺寸未计算完成。
    initProductSocialPopupGallery: function(root) {
      var $root = root ? $(root) : $(document);
      $root.find('.ws-social-module-popup__image-gallery').each(function() {
        var gallery = this;
        var $track = $(gallery).find('.ws-social-module-popup__image-track').first();
        if (!$track.length) return;
        gallery.__wsSocialGalleryReady = true;
        gallery.__wsSocialGalleryIndex = 0;
        $track.get(0).scrollLeft = 0;
        productFn.syncProductSocialPopupGallery(gallery);
        setTimeout(function() {
          productFn.syncProductSocialPopupGallery(gallery);
        }, 100);
      });
    },
    renderSizeRemmendationsText: function(sizeAccuracy) {
      var $wrap = $('.size-recommendations-wrapper');
      if (!$wrap.length) return;

      var raw = sizeAccuracy == null ? '' : String(sizeAccuracy).trim();
      if (!raw) {
        $wrap.empty().hide();
        return;
      }

      var normalized = raw.toLowerCase();
      var textMap = {
        'true to size': '<span class="size-recommendations__text">True to size</span>',
        'runs small': '<span class="size-recommendations__text">Runs small</span> — size up one',
        'runs large': '<span class="size-recommendations__text">Runs large</span> — size down one'
      };
      var displayText = textMap[normalized] || '';
      if (!displayText) {
        $wrap.empty().hide();
        return;
      }

      $wrap.html(displayText).show();
    },
    fetchProductMetafieldsData: function() {
      var curProductId = $('.product-container').attr('data-product-id');
      if (!curProductId) return Promise.resolve();
      var gid = wsNormalizeProductGid(curProductId);
      if (!gid) return Promise.resolve();
      var query = `
        query ProductMetafields($id: ID!) {
          product(id: $id) {
            title
            productFaqs: metafield(namespace: "custom", key: "product_faqs") { value }
            sizeAccuracy: metafield(namespace: "custom", key: "size_accuracy") { value }
            socialMediaList: metafield(namespace: "custom", key: "social_media_list") { value }
          }
        }
      `;
      return WS.ui.graphql({
        query: query,
        variables: { id: gid }
      }).then(function(res) {
        if (!res || !res.success || !res.data || !res.data.product) {
          productFn.renderProductFaqs('', []);
          productFn.renderSizeRemmendationsText('');
          productFn.renderProductSocialMediaList('');
          return;
        }
        var p = res.data.product;
        var metaValue = (p.productFaqs && p.productFaqs.value) || '';
        var sizeAccuracyValue = (p.sizeAccuracy && p.sizeAccuracy.value) || '';
        // 商品详情页社媒模块只取当前商品 metafield，空数据时模块会自动隐藏。
        var socialMediaValue = (p.socialMediaList && p.socialMediaList.value) || '';
        var faqList = productFn.parseProductFaqsMeta(metaValue);
        productFn.renderSizeRemmendationsText(sizeAccuracyValue);
        productFn.renderProductSocialMediaList(socialMediaValue);
        if (!metaValue) {
          console.warn('[ws-product-faqs] metafield custom.product_faqs is empty or not exposed to Storefront API', {
            productGid: gid,
            productTitle: p.title || ''
          });
        }
        productFn.renderProductFaqs(p.title || '', faqList);
      }).catch(function() {
        productFn.renderSizeRemmendationsText('');
        productFn.renderProductSocialMediaList('');
        productFn.renderProductFaqs('', []);
      });
    },
    bindEvent: function () {
      $(document).on('click', '#ws-product-faqs .ws-product-faqs__question', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(this);
        var $item = $btn.closest('.ws-product-faqs__item');
        var $list = $btn.closest('.ws-product-faqs__list');
        var willOpen = !$item.hasClass('is-open');

        $list.find('.ws-product-faqs__item').removeClass('is-open');
        $list.find('.ws-product-faqs__question').attr('aria-expanded', 'false');

        if (!willOpen) return;
        $item.addClass('is-open');
        $btn.attr('aria-expanded', 'true');
      });

      $(document).on('click', '.slide-container .slide-video-item', function() {
        var $this = $(this);
        var videoCover = $this.find('.slide-item_image');
        // var slideIndex = $('.slide-index-wrapper');
        var video = $this.find('.slide-item_video');
        var videoPlayIcon = $this.find('.video-play');
        var videoPauseIcon = $this.find('.video-play');
        var videoCtn = $this.find('.video-container').get(0);
        videoCtn.addEventListener('ended', function() {
          videoCover.show();
          video.hide();
          videoPlayIcon.show();
          // slideIndex.show();
          videoCtn.currentTime = 0;
        })
        videoCover.hide();
        video.show();
        // slideIndex.hide();
        setTimeout(function() {
          videoCtn.play();
          videoPauseIcon.hide();
        });
      });

      // 点击查看sizeguide（先同步 handle/type 到 section，避免加购弹窗改过容器后详情按钮无 data-handle 导致一直用错商品）
      $(document).on("click", ".product-sku-wrapper .size-guide-btn", function () {
        try {
          var $btn = $(this);
          var h = $btn.attr('data-product-handle');
          var t = $btn.attr('data-product-type');
          var $chart = $('[data-size-chart-section]').first();
          if ($chart.length && h) {
            $chart.attr('data-product-handle', h);
          }
          if ($chart.length) {
            if (t) {
              $chart.attr('data-product-type', String(t).toLowerCase());
            } else {
              $chart.removeAttr('data-product-type');
            }
          }
        } catch (e) {}

        if (window.WS && WS.ui && typeof WS.ui.ensureSizeChartAsyncAndOpen === 'function') {
          WS.ui.ensureSizeChartAsyncAndOpen(this);
        }

        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.globalReportMap['clickSizeGuide'],
          ext2: WS.ui.productObj.id || '',
        });
      });

        $(document).on('click', '.popupbox-container_close-icon', function() {
          productFn.closeSafeShopPopup();
        });

        $(document).on('click', '.popupbox_safe-shop .ws-main-popupbox-overlay', function() {
          productFn.closeSafeShopPopup();
        });

        $(document).on('click', '.safe-shop_tab-wrapper .safe-shop_tab-item', function() {
          $(this).addClass('active').siblings().removeClass('active');
          var key = $(this).attr('data-key');
          productFn.switchSafeShopModule(key);
          // 上报
          if (key === 'security') {
            var reportType = WS.ui.productReportMap['showShopSecurityPopProduct'];
          } else if (key === 'shipping') {
            var reportType = WS.ui.productReportMap['showShippingPopProduct'];
          } else if (key === 'returns') {
            var reportType = WS.ui.productReportMap['showReturnPopProduct'];
          }
          // 安心购弹窗模块曝光
          productFn.reportProductInfo(reportType, WS.ui.reportType['moduleShow'], 1);
        });

        $(document).on('click', '.ws-assurance', function() {
          var safeShopPopupTmpl = WS.tmpl(safeShopPopup, safeShopTabList);
          var idx = $(this).attr('data-index');
          idx = 0;
          $('body').append(safeShopPopupTmpl);
          if (productFn.isDesktopView()) {
            var $box = $('.popupbox_safe-shop').last();
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                $box.addClass('popupbox_safe-shop--open');
              });
            });
          }
          $('.safe-shop_tab-wrapper .safe-shop_tab-item')[idx].click();
          if (idx === 0) {
            setTimeout(function() {
              WS.ui.i18nFn.customClickCountryItem(function(key) {
                selectedShippingCountry = key;
                productFn.showShippingModule();
              }, 500);
            });
          }
          // 安心购模块点击上报
          productFn.reportProductInfo(WS.ui.productReportMap['clickShopSecurityProduct'], WS.ui.reportType['click'], 1);
        });

        function toggleWsAccordion(evt) {
          var $toggle = $(evt.currentTarget);
          var isDetails = $toggle.hasClass('ws-product-details__toggle') || $toggle.hasClass('ws-product-details__header');
          var isCare = $toggle.hasClass('ws-care-instructions__toggle') || $toggle.hasClass('ws-care-instructions__header');
          if (!isDetails && !isCare) return;
          var $section = $toggle.closest('.ws-product-details, .ws-care-instructions');
          if (!$section.length) return;
          var closed = $section.hasClass('ws-product-details--closed') || $section.hasClass('ws-care-instructions--closed');
          $section.toggleClass('ws-product-details--closed ws-care-instructions--closed', !closed);
          var expanded = closed ? 'true' : 'false';
          // 同步 aria-expanded 到整个 header 行（可点击区域）以及 icon toggle
          $section.find('.ws-product-details__header, .ws-product-details__toggle, .ws-care-instructions__header, .ws-care-instructions__toggle').attr('aria-expanded', expanded);
          if (closed && $section.hasClass('ws-product-details')) {
            setTimeout(function() {
              productFn.initProductDetailsDescReadMore();
            }, 0);
          }
        }
        $(document).on('click', '.ws-product-details__toggle, .ws-product-details__header, .ws-care-instructions__toggle, .ws-care-instructions__header', toggleWsAccordion);
        $(document).on('keydown', '.ws-product-details__toggle, .ws-product-details__header, .ws-care-instructions__toggle, .ws-care-instructions__header', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleWsAccordion(e);
          }
        });
        if (window.WS && WS.ui && WS.ui.bindTextReadMoreEvents) {
          [WS_PRODUCT_DETAILS_DESC_READ_MORE, WS_PRODUCT_DETAILS_DESC_READ_MORE_PC].forEach(function(d) {
            var ds = d.sel;
            WS.ui.bindTextReadMoreEvents(
              $.extend(
                {
                  blockSelector: ds.block,
                  textSelector: ds.text,
                  readMoreSelector: ds.readMore,
                  collapseSelector: ds.collapse,
                  fullTextAttr: d.fullTextAttr,
                  eventNamespace: d.eventNamespace,
                  resizeDelay: d.resizeDelay,
                  onRecalc: function() {
                    productFn.initProductDetailsDescReadMore();
                  }
                },
                wsProductDetailsDescReadMoreHtmlOpts(d)
              )
            );
          });
        }

	        // 社媒卡片点击打开详情；如果刚发生过拖动横滑，则拦截这次点击。
	        $(document).on('click', '.ws-product-social-media .ws-social-module__card', function(e) {
	          var wrapper = $(this).closest('.ws-product-social-media__list-wrapper').get(0);
	          if (wrapper && wrapper.__wsProductSocialSuppressClick) {
	            e.preventDefault();
	            return;
	          }
	          e.preventDefault();
	          var index = parseInt($(this).attr('data-block-index') || 0, 10);
	          WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_click', WS.ui.reportType['click'], this, { includePosition: true });
	          productFn.openProductSocialPopup(index);
	        });

	        // PC 左右箭头切换社媒列表，边界按钮由 updateProductSocialCarouselArrows 禁用。
	        $(document).on('click', '.ws-product-social-media__arrow', function(e) {
	          var $btn = $(this);
	          if ($btn.hasClass('is-disabled') || $btn.prop('disabled')) {
	            e.preventDefault();
	            e.stopPropagation();
	            return;
	          }
	          e.preventDefault();
	          e.stopPropagation();
	          var direction = $btn.hasClass('ws-product-social-media__arrow--next') ? 1 : -1;
	          productFn.scrollProductSocialCarousel($btn.closest('.ws-product-social-media').get(0), direction);
	        });

	        // 响应式宽度变化会影响是否溢出，重算箭头显隐和置灰状态。
	        $(window)
	          .off('resize.wsProductSocialMediaCarousel')
	          .on('resize.wsProductSocialMediaCarousel', function() {
	            productFn.initProductSocialCarousel($('#ws-product-social-media-mount'));
	          });

	        // 商品详情社媒弹窗图集：只保留左右箭头和指示点切换，不启用拖拽切换。
	        $(document).on('click', '.ws-vertical-popupbox-product-social .ws-social-module-popup__gallery-arrow', function(e) {
	          e.preventDefault();
	          e.stopPropagation();
          if ($(this).hasClass('is-disabled')) return;
          var $gallery = $(this).closest('.ws-social-module-popup__image-gallery');
          var currentIndex = parseInt($gallery.attr('data-active-index') || 0, 10);
          var nextIndex = currentIndex + ($(this).hasClass('ws-social-module-popup__gallery-arrow--next') ? 1 : -1);
          productFn.goToProductSocialPopupGallery($gallery.get(0), nextIndex);
        });

        $(document).on('click', '.ws-vertical-popupbox-product-social .ws-social-module-popup__gallery-dot', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var index = parseInt($(this).attr('data-slide-index') || 0, 10);
          productFn.goToProductSocialPopupGallery($(this).closest('.ws-social-module-popup__image-gallery').get(0), index);
        });

        // 视频区域点击播放/暂停，关闭按钮点击不触发播放状态切换。
        $(document).on('click', '.ws-vertical-popupbox-product-social .ws-social-module-popup__video-wrap, .ws-vertical-popupbox-product-social .ws-social-module-popup__image-slide--video', function(e) {
          if ($(e.target).closest('.con-close-btn').length) return;
          e.stopPropagation();
          var $wrap = $(this);
          var $video = $wrap.find('.ws-social-module-popup__video');
          var $playBtn = $wrap.find('.ws-social-module-popup__play-btn');
          if (!$video.length || !$playBtn.length) return;
          if ($video[0].paused) {
            $video[0].play();
            $playBtn.hide();
          } else {
            $video[0].pause();
            $playBtn.show();
          }
        });

        $(document).on('play', '.ws-vertical-popupbox-product-social .ws-social-module-popup__video', function() {
          $(this).siblings('.ws-social-module-popup__play-btn').hide();
        });

        $(document).on('pause ended', '.ws-vertical-popupbox-product-social .ws-social-module-popup__video', function() {
          $(this).siblings('.ws-social-module-popup__play-btn').show();
        });

        // 社媒弹窗里的加购图标复用商品页加购弹窗，成功后由通用逻辑关闭社媒详情。
        $(document).on('click', '.ws-vertical-popupbox-product-social .ws-social-module-popup__product-action', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (!WS.ui || !WS.ui.productPopupFn || !WS.ui.productPopupFn.lsCreatePopupHandle) return;
          var productInfo;
          try {
            productInfo = WS.ui.getProductData(productId, productDataDom);
          } catch (err) {
            productInfo = productFn.getProductDetailJson();
          }
          if (!productInfo || !productInfo.id) return;
          var socialTrackData = WS.ui.getSocialPostTrackData ? WS.ui.getSocialPostTrackData(this) : {};
          WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
          WS.ui.productPopupFn.lsCreatePopupHandle({
            data: productInfo,
            handle: 'social-module',
            listType: 'social-module',
            aid: 'social-module',
            socialPostId: socialTrackData.postId,
            socialPlatform: socialTrackData.platform,
            socialPos: socialTrackData.pos,
            socialProductId: productInfo.id,
            dataDom: this
          });
          if (WS.ui.productPopupFn.addToBagReportExposureClickHanlde && WS.ui.reportType && WS.ui.productReportMap) {
            WS.ui.productPopupFn.addToBagReportExposureClickHanlde(productInfo, WS.ui.reportType['click'], WS.ui.productReportMap['clickAddtobagIcon']);
          }
        });

        $(document).on('keydown', '.ws-vertical-popupbox-product-social .ws-social-module-popup__product-action', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
          }
        });

      $(document).on("click", '.product-preview_close-wrapper, .product-preview_mask', function() {
        $('.product-preview_dialog').hide();
      })

      $(document).on("click", ".product-page__size-item", function (e) {
        var skuWrapper = $('.product-sku-wrapper');
        var $sizeItems = skuWrapper.find('.product-page__size-item');
        $sizeItems.attr('aria-pressed', 'false');
        skuWrapper.find('.size-selected-value').text('');
        var size = $(this).attr("data-value");
        var variantId = $(this).attr("data-variant-id");
        selectedSku = variantId
        // 获取尺码状态：是否售罄
        if ($(this).hasClass('sold-out')) {
          selectedSize = '';
          selectedSku = '';
          WS.ui.selectedSize = '';
          skuWrapper.find('.size-selected-value').text('');
          $(this).removeClass("selected").siblings().removeClass("selected");
          renderProductUsWarehouseStockTip();
          // 点击售罄尺码时，同步加购按钮售罄样式
          setAddToBagSoldOut(true);
          setSizeFeedback(WS.ui.errorMsgMap.soldout);
          WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
        } else {
          selectedSize = size;
          WS.ui.selectedSize = selectedSize;
          setAddToBagSoldOut(false);
          $(this).addClass("selected").siblings().removeClass("selected");
          $(this).attr('aria-pressed', 'true');
          setSizeFeedback('');
          announceCartResult('');
          skuWrapper.find('.size-selected-value').text(selectedSize);

          var selectedVariant = WS.ui.productObj.variants.find(variantItem => String(variantItem.id) === String(variantId));

          // 更新价格；切换颜色后若数据短暂未同步，不阻断下方选中尺码提示刷新。
          if (selectedVariant) {
            WS.ui.productPopupFn.handleSelectedVairantPrice({
              variant: selectedVariant,
              productContainer: '.product-container',
              priceWrapper: '#product-current-price',
              comparePriceWrapper: '#product-compare-price'
            });
          }
          
          // 显示选中尺码的 2 日达 / 库存 / 预售信息
          renderProductSelectedSizeStockTip(this);

          // 判断是否需要滚动到Add to Cart区域
          productFn._clickSizeLookBodySizeHandle();
        }
        // // 上报
        // var param = {
        //   "products": {
        //     id: $('.product-container').attr('data-product-id') + '',
        //     size: size,
        //   }
        // };
        // WS.stat({
        //   eid: WS.ui.reportType['click'],
        //   ext1: WS.ui.productReportMap['clickProductSize'],
        //   ext2: JSON.stringify(param || {})
        // });
      });

      $(document).on("click", ".product-page__color-item", function () {
        var $colorItem = $(this);
        var productId = $colorItem.attr('data-product-id');
        var productDataDom = $('.js-product-detail-json');
        var productData = WS.ui.getProductData(productId, productDataDom);
        var mergeSkcsList = Array.isArray(productData.mergeSkcs) ? productData.mergeSkcs : [];
        if (mergeSkcsList.length >= 1) {
          WS.ui.productPopupFn.switchMergeSkcProduct(
            { 
              colorItem: $colorItem, 
              mergeSkcsList: mergeSkcsList,
              productContainer: '.product-container',
              titleWrapper: '.product-title-wrapper',
              sizeContainer: '.size-wrapper .sku-sizes-inner',
              sizeItemClassName: 'product-page__size-item',
              isReplaceUrl: true,
              isRenderMedia: true,
              isReplaceJSON: true,
              priceWrapper: '#product-current-price',
              comparePriceWrapper: '#product-compare-price'
            }
          );
        }
        // 切色后用目标商品自己的集合状态同步主图标签和价格区营销提醒。
        updateProductCollectionMarketingState(productData);
        var color = $colorItem.attr("data-value");
        selectedColor = $colorItem.attr("data-product-id");
        WS.ui.selectedColor = color || '';
        // 切换颜色时清空已选尺码，避免误判库存
        selectedSize = '';
        selectedSku = '';
        WS.ui.selectedSize = '';
        // 色卡切换后按钮回到待选尺码状态；新尺码是否售罄由尺码 DOM 和加购前校验判断。
        setAddToBagSoldOut(false);
        $('#in-stock-wrapper').html('');
        setSizeFeedback('');
        announceCartResult('');
        // 显示选中颜色
        $('.product-sku-wrapper').find('.color-selected-value').text(color);
        $colorItem.addClass("selected").attr('aria-pressed', 'true').siblings('.product-page__color-item').removeClass("selected").attr('aria-pressed', 'false');

        // 重置size选择
        var $sizeSelectedValue = $('.product-sku-wrapper').find('.size-selected-value');
        $sizeSelectedValue.text(`${WS.$t('product.details.select_size')}`);
        $('#add-to-bag').text(`${WS.$t('public.add_pop.add_to_bag_btn')}`);
        renderProductUsWarehouseStockTip();

        setTimeout(function() {
          productId = productPage.attr('data-product-id') || '';
          productFn.updateProductDetailsModule();
          productFn.fetchProductMetafieldsData();
          productFn.requestAlsoLoveList();
          productFn.requestCompleteTheLookList();
        }, 100);

        // 上报
        // 获取sku的颜色值（与当前 mergeSkcs 项的 variants 一致）
      //   var pj = productObj.productJson;
      //   var skuColorList =
      //     pj && Array.isArray(pj.variants)
      //       ? pj.variants.filter(function(item) {
      //           return WS.ui.getVariantColorValue(item, productObj.options_with_values || []) === color;
      //         })
      //       : [];
      //   var skuColor = skuColorList[0] && skuColorList[0].sku ? skuColorList[0].sku.split('-')[1] : color;
      //   var productPageDom = $('.product-container');
      //   var param = {
      //     "products": {
      //       id: productPageDom.attr('data-product-id') + '',
      //       title: productPageDom.find('.product-title-wrapper').text(),
      //       color: skuColor,
      //     }
      //   };
      //   WS.stat({
      //     eid: WS.ui.reportType['click'],
      //     ext1: WS.ui.productReportMap['clickProductColor'],
      //     ext2: JSON.stringify(param || {})
      //   });
      });


      $(document).on("click", "#add-to-bag", function () {
        var $button = $(this);
        _checkVariant(function () {
          if ($button.hasClass('sold-out')) {
            announceCartResult(WS.ui.errorMsgMap.soldout, true);
            WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
            return;
          }
          productFn.addToCart(selectedSku);
        });
      });

      // PDP 加购后自动打开购物车时，关闭购物车再按空闲状态锚定 Complete The Look。
      $(document).on("click", ".cart-header__close,.cart-drawer_container_overlay", function () {
        if (!productFn._anchorCompleteLookAfterCartClose) return;
        productFn._anchorCompleteLookAfterCartClose = false;
        productFn.scheduleCompleteLookAnchorAfterCartClose();
      });

      // 轮播图
      $(document).on('touchend','.slide-container-wrapper',function(){
        if (!mediaSlider || typeof mediaSlider.getIndex !== 'function') return;
        // 上报
        var skuId = $(".slide-container-wrapper").find(`.slide-item[data-index='${mediaSlider.getIndex()}']`).attr("data-id");
        productFn.sliderPictureExposure(WS.ui.productReportMap['showProductPicture'], WS.ui.reportType['moduleShow'], skuId, mediaSlider.getIndex());
      });

      // -------模块展示曝光上报-------
      // 安心购模块曝光
      productFn.modelShowHandle(document.querySelector('.product-card-show-container'), WS.ui.productReportMap['showShopSecurityProduct']);

      function _checkVariant(callback) {
        if (!selectedColor) {
          announceCartResult(WS.ui.errorMsgMap.noColor, true);
          return WS.ui.toastShowHandle(WS.ui.errorMsgMap.noColor);
        }

        if (!selectedSize) {
          setSizeFeedback(WS.ui.errorMsgMap.noSize);
          WS.ui.toastShowHandle(WS.ui.errorMsgMap.noSize);
          var firstSizeButton = document.querySelector('.product-page__size-item:not(.sold-out)') || document.querySelector('.product-page__size-item');
          if (firstSizeButton) firstSizeButton.focus();
          return;
        }

        callback && typeof callback === "function" && callback();
      }
    },

    updateProductDetailsModule: function() {
      var $wrap = $('.product-details-wrapper');
      if (!$wrap.length) return;
      var path = window.location.pathname;
      var search = window.location.search || '';
      var sep = search ? '&' : '?';
      var url = WS.site.baseUrl + path + search + sep + 'section_id=westyle-product-details';
      WS.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success: function(html) {
          if (typeof html !== 'string' || !html) return;
          $wrap.html(html.trim());
          wsSanitizeProductDetailsRichText();
          productFn.initProductDetailsDescReadMore();
        }
      });
    },

    // 点击size，滚动到Add to Cart 按钮位置方法
    _clickSizeLookBodySizeHandle: function () {
      // addtobag距离顶部的高度
      var addToBagTop = $(".product-detail_btn-wrapper").offset().top;
      // addtobag盒子的高度
      var addToBagBoxHeight = $(".product-detail_btn-wrapper").height();
      // 滚动的高度
      var scrollHeight = $(window).scrollTop();
      // 视图的高度
      var height = $(window).height();
      // 判断当addtobag距离顶部的高度大于视图的高度时 并且 滚动的高度小于addtobag距离顶部的高度-视图的高度+盒子的高度时，滚动到addtobag区域
      if (addToBagTop+addToBagBoxHeight > height && scrollHeight < (addToBagTop-height+addToBagBoxHeight)) {
        // 滚动距离为：bodysize距离顶部的高度-视图的高度+bodysize盒子的高度+底部遮挡的高度
        $(window).scrollTo && $(window).scrollTo({ pos: (addToBagTop-height)+addToBagBoxHeight, durTime: 200 });
      }
    },

    // alsolike滚动方法
    alsoLikeScrollToHandle: function () {
      var alsolikeTop = $("#ws-product-alsolove").offset().top - 180;
      var scrollHeight = $(window).scrollTop();
      // 判断当滚动的高度小于alsolike离顶部的距离时，滚动到alsolike区域
      if (scrollHeight < alsolikeTop) {
        $(window).scrollTo && $(window).scrollTo({pos : alsolikeTop});
      }
    },

    /** 尺码未选时：已在视口内则不滚；否则滚至 .sku-wrapper.size-wrapper 在视口垂直居中 */
    scrollToSizeWrapper: function () {
      var $target = $('.product-sku-wrapper .sku-wrapper.size-wrapper');
      if (!$target.length) return;
      var elTop = $target.offset().top;
      // Zepto 无 outerHeight，用原生 offsetHeight（含 padding/border，与 jQuery outerHeight 一致）
      var node = $target[0];
      var elH = node ? node.offsetHeight : 0;
      var elBottom = elTop + elH;
      var scrollTop = $(window).scrollTop();
      var winH = $(window).height();
      var viewBottom = scrollTop + winH;

      // 整块已在可视区域内：不滚动
      if (elTop >= scrollTop && elBottom <= viewBottom) {
        return;
      }

      // 元素中心对齐视口垂直中心
      var elCenter = elTop + elH / 2;
      var targetScroll = Math.round(elCenter - winH / 2);
      var maxScroll = Math.max(0, $(document).height() - winH);
      if (targetScroll < 0) targetScroll = 0;
      else if (targetScroll > maxScroll) targetScroll = maxScroll;

      if ($(window).scrollTo) {
        $(window).scrollTo({ pos: targetScroll, durTime: 350 });
      } else {
        window.scrollTo(0, targetScroll);
      }
    },

    // 上报数据整合
    reportProductInfo: function(ext1, reportType, type, data) {
      // 上报参数
      // 基础参数
      var dataJson = {};
      var productJson = WS.ui.productObj;
      dataJson.id = productJson.id + '';
      dataJson.title = productJson.title;
      // 根据类型判断数据格式
      if ( type == 2 ) {
        // 判断是否有sku
        if (selectedSku) {
          // 匹配对应的sku
          dataJson.sku = selectedSku;
        }
        dataJson.price = productJson.price/100;
      } else if ( type == 3 ) {
        dataJson.sku = '0';
        dataJson.price = productJson.price/100;
      }
      var param = {
        "products": dataJson
      }
      // 上报
      if ( type == 1 ) {
        WS.stat({
          eid: reportType,
          ext1,
          ext2: JSON.stringify(param || ''),
          ...data
        });
      } else {
        var ext4 = {
          total: productJson.price / 100,
          currency: WS.site.currency,
          sum: 1
        }
        WS.stat({
          eid: reportType,
          ext1,
          ext2: JSON.stringify(param || ''),
          ext3: document.referrer ? WS.cookie.get("ws-pagefrom") : "none",
          ext4: JSON.stringify(ext4),
          ext6: !selectedSize ? 'op=no_size' : 'op=ok',
        });
      }
    },
    addToCart: function (id) {
      // PDP 加购前最后兜底，避免按钮状态过期时仍然请求 /cart/add.js。
      var selectedVariant = WS.ui.productObj && Array.isArray(WS.ui.productObj.variants)
        ? WS.ui.productObj.variants.find(function(variantItem) {
          return variantItem && String(variantItem.id) === String(id);
        })
        : null;
      if (WS.ui.isVariantOnlineSellable && selectedVariant && !WS.ui.isVariantOnlineSellable(selectedVariant)) {
        setAddToBagSoldOut(true);
        announceCartResult(WS.ui.errorMsgMap.soldout, true);
        WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
        return;
      }
      WS.ajax({
        url: WS.ui.routes.addCartItemUrl,
        type: "POST",
        data: {
          id,
          quantity: 1,
        },
        success: function () {
          WS.ui.setAddCartAnimation($('#westyle-image').attr('src'));
          // 加购接口成功只代表商品已提交到购物车，还需要等待 cart-data 刷新完成。
          // 后续是否打开购物车、是否滚动到 Complete The Look，都依赖刷新后的购物车数量。
          var cartInfoPromise = WS.ui.cartFn && WS.ui.cartFn.getCartDataInfo && WS.ui.cartFn.getCartDataInfo(2, 1);
          var handleAfterCartUpdated = function (cartUpdateFailed) {
            var cartCount = WS.ui.cartFn && WS.ui.cartFn.getCartCount ? Number(WS.ui.cartFn.getCartCount()) || 0 : 0;
            var successMessage = WS.$t('public.toast.add_succ_toast');
            announceCartResult(successMessage, false);
            WS.ui.toastShowHandle(successMessage);

            if (!cartUpdateFailed && cartCount === 1) {
              // 首件商品加购后不打开购物车，直接引导用户看当前商品的 Complete The Look。
              productFn.scrollToCompleteTheLook();
            } else {
              // 多件商品仍打开购物车；只有确认数量 > 1 时，关闭购物车后才触发延迟锚定。
              // 如果 cart-data 刷新失败，保留旧逻辑打开购物车，但不自动锚定，避免用错误数量做判断。
              productFn._anchorCompleteLookAfterCartClose = !cartUpdateFailed && cartCount > 1;
              WS.ui.cartFn && WS.ui.cartFn.handleOpenDrawer && WS.ui.cartFn.handleOpenDrawer('add_bag');
            }

            // 上报
            productFn.reportProductInfo(WS.ui.productReportMap['clickAddtobagProduct'], WS.ui.reportType['click'], 2);
          };

          if (cartInfoPromise && typeof cartInfoPromise.then === 'function') {
            cartInfoPromise.then(function () {
              handleAfterCartUpdated(false);
            }).catch(function () {
              handleAfterCartUpdated(true);
            });
          } else {
            handleAfterCartUpdated(false);
          }
        },
        error: function (error) {
          try {
            var errorRes = error.response ? JSON.parse(error.response) : {};
            if (errorRes.message) {
              announceCartResult(errorRes.message, true);
              WS.ui.toastShowHandle(errorRes.message);
            } else {
              announceCartResult(WS.ui.errorMsgMap.baseError, true);
              WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
            }
          } catch (e) {
            announceCartResult(WS.ui.errorMsgMap.baseError, true);
            WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
          }
        }
      });
    },

    // 模块曝光方法
    modelShowHandle: function (dom, reportType, threshold = 1, data) {
      if ($(dom).length == 0) {
        return false;
      }
      var config = {
        threshold: [threshold]
      }
      WS.observe.intersection(dom, function(entries, observer) {
        for (let i = 0, len = entries.length; i < len; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            // 上报
            // 判断是否为个性化模块
            if (reportType === 'feature.product') {
              // 基础参数
              var dataJson = {};
              dataJson.id = WS.ui.productObj.id + '';
              dataJson.title = WS.ui.productObj.title;
              var param = {
                "products": dataJson
              }
              WS.stat({
                eid: WS.ui.reportType['moduleShow'],
                ext1: reportType,
                ext2: JSON.stringify(param || ''),
                ext3: `pos=${$(dom).index()+1}`
              });
            } else {
              productFn.reportProductInfo(reportType, WS.ui.reportType['moduleShow'], 1, data);
            }
          }
        }
      }, config)
    },

    initSlide: function () {
      if (productFn.isDesktopView()) {
        mediaSlider = null;
        $('.slide-num-box-current').text(1);
        return;
      }
      mediaSlider = null;
      $('.slide-num-box-current').text(1);
      $('.slide-index-item').eq(0).addClass('active');
      mediaSlider = new WS.Slider({
        container: ".slide-container-wrapper",
        endCallback: function(index) {
          var currentSlideItem = $('.slide-container .slide-item').eq(index + 1);
          var currentSlideItemPlayIcon = currentSlideItem.find('.video-play');
          var currentSlideMediaType = currentSlideItem.attr('data-media-type');
          if (currentSlideMediaType === 'video') {
            var currentSlideItemEl = currentSlideItem.find('.video-container').get(0);
            currentSlideItemEl.pause();
            currentSlideItemPlayIcon.show();
          }
          $('.slide-num-box-current').text(index + 1);
          $('.slide-index-item').eq(index).addClass('active').siblings().removeClass('active');
        }
      });
      // 上报
      var skuId = $(".slide-container-wrapper").find(".slide-item[data-index='0']").attr("data-id");
      productFn.sliderPictureExposure(WS.ui.productReportMap['showProductPicture'], WS.ui.reportType['moduleShow'], skuId, mediaSlider.getIndex());
    },
    // 轮播图图片曝光方法
    sliderPictureExposure: function (ext1, reportType, sku, index) {
      var productJson= WS.ui.getProductData(productId, productDataDom);
      var param = {
        "products": {
          id: productJson.id + '',
          title: productJson.title,
          sku: sku
        }
      }
      WS.stat({
        eid: reportType,
        ext1: ext1,
        ext2: JSON.stringify(param || {}),
        ext3: `pos=${index+1}`,
      });
    },
    
    // 初始化尺码区：不默认选中任何尺码，但展示「选择尺码」文案与售罄样式/数量文案
 
    // Also Love（猜你喜欢）入口：
    // - DOM 在 Liquid 中默认隐藏（display:none），这里负责触发拉取 section 并在“有卡片”时展示
    // - 注意：展示判断依赖 `.ws-product-block`，如果商品卡片结构/类名被改，会导致“有数据但不展示”
    getAlsoLoveListHandle: function() {
      alsoLoveDom = $('#ws-product-alsolove');
      productId = productPage.attr("data-product-id") || "";
      productFn.requestAlsoLoveList();
    },

    // Also Love：底部滚动指示器（PC 端）状态缓存
    // - 使用 RAF + ResizeObserver + scroll 监听，避免滚动时频繁读写布局造成掉帧
    _alsoLoveIndRaf: null,
    _alsoLoveScrollRO: null,
    _alsoLoveScrollEl: null,
    _alsoLoveScrollHandler: null,
    _alsoLoveScrollListenerOpts: { passive: true },
    _alsoLoveIndCache: null,
    _alsoLoveArrowCf: null,
    _alsoLoveArrowListingEl: null,
    _alsoLoveIndTrackPx: 300,
    _alsoLoveIndMetrics: null,

    getAlsoLoveIndicatorCache: function() {
      if (productFn._alsoLoveIndCache) return productFn._alsoLoveIndCache;
      if (!alsoLoveDom || !alsoLoveDom.length) return null;
      var el = alsoLoveDom.find('.ws-also-love-listbox .ws-featured-collection-product-list').get(0);
      var ind = alsoLoveDom.find('.ws-also-love-scroll-indicator').get(0);
      var thumb = alsoLoveDom.find('.ws-also-love-scroll-indicator__thumb').get(0);
      if (!el || !ind || !thumb) return null;
      productFn._alsoLoveIndCache = { el: el, ind: ind, thumb: thumb };
      return productFn._alsoLoveIndCache;
    },
    scheduleAlsoLoveScrollIndicatorUpdate: function() {
      if (productFn._alsoLoveIndRaf !== null) return;
      productFn._alsoLoveIndRaf = requestAnimationFrame(function() {
        productFn._alsoLoveIndRaf = null;
        productFn.updateAlsoLoveScrollIndicator();
      });
    },
    measureAlsoLoveScrollIndicator: function() {
      var mq = window.matchMedia && window.matchMedia('(min-width: 750px)');
      // 指示器仅服务 PC 横向列表；移动端不计算，避免无意义开销
      if (!mq || !mq.matches) {
        productFn._alsoLoveIndMetrics = null;
        return;
      }
      var cache = productFn.getAlsoLoveIndicatorCache();
      if (!cache) {
        productFn._alsoLoveIndMetrics = null;
        return;
      }
      var el = cache.el;
      var indEl = cache.ind;
      var thumbEl = cache.thumb;
      var scrollWidth = el.scrollWidth || 0;
      var clientWidth = el.clientWidth || 0;
      var maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 1 || clientWidth <= 0) {
        indEl.classList.add('ws-also-love-scroll-indicator--hidden');
        productFn._alsoLoveIndMetrics = { maxScroll: 0, travel: 0, thumbW: 0 };
        return;
      }
      indEl.classList.remove('ws-also-love-scroll-indicator--hidden');
      var trackW = productFn._alsoLoveIndTrackPx;
      var ratio = clientWidth / scrollWidth;
      if (ratio > 1) ratio = 1;
      var thumbW = Math.max(ratio * trackW, 8);
      var travel = Math.max(trackW - thumbW, 0);
      // 只在测量时写 width，避免滚动时反复写样式导致掉帧
      thumbEl.style.width = thumbW + 'px';
      productFn._alsoLoveIndMetrics = { maxScroll: maxScroll, travel: travel, thumbW: thumbW };
    },
    updateAlsoLoveScrollIndicator: function() {
      var mq = window.matchMedia && window.matchMedia('(min-width: 750px)');
      if (!mq || !mq.matches) return;
      var cache = productFn.getAlsoLoveIndicatorCache();
      if (!cache) return;
      var el = cache.el;
      var indEl = cache.ind;
      var thumbEl = cache.thumb;
      var metrics = productFn._alsoLoveIndMetrics;
      if (!metrics) {
        productFn.measureAlsoLoveScrollIndicator();
        metrics = productFn._alsoLoveIndMetrics;
      }
      if (!metrics || metrics.maxScroll <= 1) return;
      var leftPx = metrics.travel > 0 ? ((el.scrollLeft || 0) / metrics.maxScroll) * metrics.travel : 0;
      thumbEl.style.transform = 'translate3d(' + leftPx + 'px, 0, 0)';

      // 同一帧内顺便同步箭头状态，避免额外 scroll 监听带来的抖动/卡顿
      var cf = productFn._alsoLoveArrowCf;
      var listingEl = productFn._alsoLoveArrowListingEl;
      if (cf && listingEl && cf.updateFeaturedCollectionArrows) {
        cf.updateFeaturedCollectionArrows(listingEl);
      }
    },
    setupAlsoLoveScrollResizeObserver: function() {
      // 横向滚动发生在列表本身（.ws-featured-collection-product-list）
      var $el = alsoLoveDom.find('.ws-also-love-listbox .ws-featured-collection-product-list').first();
      if (!$el.length) {
        productFn.scheduleAlsoLoveScrollIndicatorUpdate();
        return;
      }
      var el = $el[0];
      productFn._alsoLoveIndCache = null;
      productFn._alsoLoveIndMetrics = null;
      if (productFn._alsoLoveScrollEl && productFn._alsoLoveScrollHandler) {
        productFn._alsoLoveScrollEl.removeEventListener('scroll', productFn._alsoLoveScrollHandler, productFn._alsoLoveScrollListenerOpts);
      }
      productFn._alsoLoveScrollHandler = function() {
        productFn.scheduleAlsoLoveScrollIndicatorUpdate();
      };
      el.addEventListener('scroll', productFn._alsoLoveScrollHandler, productFn._alsoLoveScrollListenerOpts);
      productFn._alsoLoveScrollEl = el;
      $el.off('scroll.wsAlsoLoveInd');
      if (typeof ResizeObserver === 'undefined') {
        productFn.scheduleAlsoLoveScrollIndicatorUpdate();
        return;
      }
      if (productFn._alsoLoveScrollRO) {
        productFn._alsoLoveScrollRO.disconnect();
        productFn._alsoLoveScrollRO = null;
      }
      // inner 容器可以直接用 el（子项变动时 ResizeObserver 仍能触发）
      var inner = $el.get(0);
      productFn._alsoLoveScrollRO = new ResizeObserver(function() {
        productFn._alsoLoveIndMetrics = null;
        productFn.measureAlsoLoveScrollIndicator();
        productFn.scheduleAlsoLoveScrollIndicatorUpdate();
      });
      productFn._alsoLoveScrollRO.observe(el);
      if (inner) productFn._alsoLoveScrollRO.observe(inner);
      productFn.measureAlsoLoveScrollIndicator();
      productFn.scheduleAlsoLoveScrollIndicatorUpdate();
    },
    _storefrontCrossSellDidLoad: false,
    loadStorefrontCrossSellModules: function() {
      productFn.applyCompleteTheLookLayout();
    },

    applyCompleteTheLookLayout: function() {
      var $wrap = $('#ws-product-complete-the-look');
      if (!$wrap.length) return;
      var $list = $wrap.find('.ws-featured-collection-product-list').first();
      if (!$list.length) return;

      var count = $list.children('.ws-product-block').length;
      $list.removeClass('ws-ctl-layout-3 ws-ctl-layout-4');
      if (count === 3) $list.addClass('ws-ctl-layout-3');
      if (count >= 4) $list.addClass('ws-ctl-layout-4');
    },

    getCompleteTheLookAnchorTarget: function() {
      var $wrap = $('#ws-product-complete-the-look');
      if (!$wrap.length || $wrap.css('display') === 'none') return $();
      if (!$wrap.find('.ws-product-block').length) return $();
      return $wrap;
    },

    cancelCompleteLookScroll: function() {
      if (completeLookScrollTimer) {
        clearTimeout(completeLookScrollTimer);
        completeLookScrollTimer = null;
      }
    },

    // Complete The Look 是异步 section，锚定前不能假设 DOM 一定已经存在。
    // 这个方法会在短时间内轮询目标模块：
    // - 找到真实模块且里面有商品卡片时才滚动；
    // - 如果 mount 占位还在，会主动触发 requestCompleteTheLookList；
    // - 超时后执行 onAbort 清理监听，不留下空闲计时器或事件绑定。
    scrollToCompleteTheLook: function(options) {
      options = options || {};
      productFn.cancelCompleteLookScroll();
      var startedAt = Date.now();
      var timeout = options.timeout || 4000;
      var requestedCompleteLook = false;

      function cleanupAnchorWait() {
        options.beforeScroll && options.beforeScroll();
      }

      function tryScroll() {
        if (options.isCanceled && options.isCanceled()) return;
        var $target = productFn.getCompleteTheLookAnchorTarget();
        if ($target.length) {
          completeLookScrollTimer = null;
          cleanupAnchorWait();
          var targetTop = Math.max(0, $target.offset().top - 180);
          if ($(window).scrollTo) {
            $(window).scrollTo({ pos: targetTop, durTime: 450 });
          } else {
            window.scrollTo(0, targetTop);
          }
          return;
        }

        if (!requestedCompleteLook && !$('#ws-product-complete-the-look').length && $('#ws-product-complete-the-look-mount').length) {
          requestedCompleteLook = true;
          productFn.requestCompleteTheLookList();
        }

        if (Date.now() - startedAt < timeout) {
          completeLookScrollTimer = setTimeout(tryScroll, 150);
          return;
        }

        completeLookScrollTimer = null;
        options.onAbort && options.onAbort();
      }

      tryScroll();
    },

    cancelCompleteLookIdleAnchor: function() {
      if (completeLookCloseTimer) {
        clearTimeout(completeLookCloseTimer);
        completeLookCloseTimer = null;
      }
      if (completeLookIdleTimer) {
        clearTimeout(completeLookIdleTimer);
        completeLookIdleTimer = null;
      }
      if (completeLookIdleCleanup) {
        completeLookIdleCleanup();
        completeLookIdleCleanup = null;
      }
      productFn.cancelCompleteLookScroll();
    },

    // 多件商品加购后会先打开购物车；用户关闭购物车后，不马上滚动。
    // 这里等待 1 秒“无动作”窗口：
    // - 如果用户开始滚动、触摸、点击、键盘操作或切换/离开页面，说明用户有自己的意图，取消自动锚定；
    // - 如果 1 秒内没有动作，再滚到 Complete The Look；
    // - 所有监听都通过 cleanupIdleListeners 统一解绑，避免重复绑定。
    waitForIdleThenScrollCompleteLook: function(delay) {
      productFn.cancelCompleteLookIdleAnchor();
      var canceled = false;
      var namespace = '.completeLookIdleAnchor';
      var windowEvents = 'scroll' + namespace + ' wheel' + namespace;
      var documentEvents = 'touchstart' + namespace + ' touchmove' + namespace + ' mousedown' + namespace + ' keydown' + namespace;
      var cancel = function() {
        canceled = true;
        productFn.cancelCompleteLookIdleAnchor();
      };
      var cancelOnVisibilityChange = function() {
        if (document.hidden) cancel();
      };
      var cleanupIdleListeners = function() {
        if (completeLookIdleCleanup) {
          completeLookIdleCleanup();
          completeLookIdleCleanup = null;
        }
      };

      completeLookIdleCleanup = function() {
        $(window).off(windowEvents, cancel);
        $(document).off(documentEvents, cancel);
        window.removeEventListener('pagehide', cancel);
        document.removeEventListener('visibilitychange', cancelOnVisibilityChange);
      };

      $(window).on(windowEvents, cancel);
      $(document).on(documentEvents, cancel);
      window.addEventListener('pagehide', cancel);
      document.addEventListener('visibilitychange', cancelOnVisibilityChange);

      completeLookIdleTimer = setTimeout(function() {
        completeLookIdleTimer = null;
        productFn.scrollToCompleteTheLook({
          timeout: 4000,
          isCanceled: function() { return canceled; },
          beforeScroll: cleanupIdleListeners,
          onAbort: cleanupIdleListeners
        });
      }, delay || 1000);
    },

    scheduleCompleteLookAnchorAfterCartClose: function() {
      // 购物车关闭有 350ms 动画。等动画结束后再开始 1 秒无动作计时，
      // 避免关闭按钮点击本身或抽屉动画造成误判。
      productFn.cancelCompleteLookIdleAnchor();
      completeLookCloseTimer = setTimeout(function() {
        completeLookCloseTimer = null;
        productFn.waitForIdleThenScrollCompleteLook(1000);
      }, 350);
    },

    /** Shopify ?sections= 返回的 JSON 中取对应 section 的 HTML 字符串 */
    extractWestyleSectionHtml: function(res, sectionKey) {
      if (res == null) return '';
      if (typeof res === 'string') {
        try {
          return (JSON.parse(res) || {})[sectionKey] || '';
        } catch (e) {
          return '';
        }
      }
      if (typeof res === 'object' && res[sectionKey]) {
        return res[sectionKey] || '';
      }
      return '';
    },

    /** 将 section 渲染结果中的根 shell 插入商详：优先替换已有 shell，否则替换 mount 占位 */
    mountWestyleSectionShell: function(responseHTML, shellSelector, mountSelector) {
      if (!responseHTML || typeof responseHTML !== 'string') return $();
      var trimmed = responseHTML.trim();
      if (!trimmed) return $();
      var $parsed = $('<div>').html(trimmed);
      var $newShell = $parsed.find(shellSelector).first();
      if (!$newShell.length) return $();
      var $existing = $(shellSelector);
      var $mount = $(mountSelector);
      if ($existing.length) {
        $existing.replaceWith($newShell);
      } else if ($mount.length) {
        $mount.replaceWith($newShell);
      } else {
        productPage.append($newShell);
      }
      return $(shellSelector);
    },

    // Also Love：通过 Shopify `?sections=` 拉取服务端渲染的 HTML（避免客户端拼卡片导致结构不一致）
    // - 成功后替换 `#ws-product-alsolove`（或 mount 占位），并补齐轮播箭头、曝光统计、图片懒加载
    requestAlsoLoveList: function() {
      alsoLoveDom = $('#ws-product-alsolove');
      var sectionKey = 'westyle-also-like-data';
      var sectionUrl = `${WS.site.baseUrl}${window.location.pathname}?sections=${sectionKey}`;

      var finalizeAlsoLikeLayout = function() {
        // 这里用 flex 强制显示模块：Liquid 默认隐藏（display:none），避免“无数据时闪一下”
        alsoLoveDom.css('display', 'flex');
        productFn.setupAlsoLoveScrollResizeObserver();
        var cf = WS.ui && WS.ui.collectionFn;
        var $listing = alsoLoveDom.find('.ws-also-love-listbox.ws-featured-collection-listing').first();
        if (cf && $listing.length) {
          productFn._alsoLoveArrowCf = cf;
          productFn._alsoLoveArrowListingEl = $listing[0];
          cf.updateFeaturedCollectionArrows && cf.updateFeaturedCollectionArrows($listing[0]);
          cf.layoutFeaturedCollectionCarouselArrows && cf.layoutFeaturedCollectionCarouselArrows($listing[0]);
        }
      };

      WS.ajax({
        url: sectionUrl,
        type: 'GET',
        dataType: 'html',
        success: function(res) {
          var responseHTML = productFn.extractWestyleSectionHtml(res, sectionKey);
          alsoLoveDom = productFn.mountWestyleSectionShell(responseHTML, '#ws-product-alsolove', '#ws-product-alsolove-mount');
          finalizeAlsoLikeLayout();
          // 动态插入新卡片后，需要重新触发曝光与懒加载初始化
          WS.ui.globalListExposureHandle && WS.ui.globalListExposureHandle();
          WS.ui.initImgLazyloadHandle && WS.ui.initImgLazyloadHandle();
        },
        error: function() {
          // 失败时不显示模块，避免留一个空壳影响页面布局
          alsoLoveDom.css('display', 'none');
        },
        complete: function() {
          setTimeout(function() {
            var $list = alsoLoveDom.find('.ws-also-love-listbox .ws-featured-collection-product-list');
            if (!$list.length || !$list.find('.ws-product-block').length) {
              alsoLoveDom.css('display', 'none');
              return;
            }
          }, 3000);
        }
      });
    },

    insertAlsoLoveReviewsStars: function(list) {
      if (!list || !list.length) return;
      if (!WS.ui.routes.batchGetProductRating) {
        productFn.scheduleAlsoLoveScrollIndicatorUpdate();
        return;
      }
      var productIds = list.map(function(item) { return item.productId; });
      var skcTitleList = list.map(function(item) { return item.skcTitle || ''; });
      var $container = alsoLoveDom.find('.ws-featured-collection-product-list');
      var renderCompact = function(score) {
        var num = Number(score);
        if (Number.isNaN(num)) num = 5;
        var text = num.toFixed(1);
        return (
          '<div class="ws-rating-compact" aria-label="Rating ' + text + ' out of 5">' +
            '<div class="ws-rating-compact__score">' + text + '</div>' +
            '<div class="reviews-star-wrapper" aria-hidden="true">' +
              '<div class="reviews-star yellow-full-star small"></div>' +
            '</div>' +
          '</div>'
        );
      };
      WS.ajax({
        url: WS.ui.routes.batchGetProductRating,
        type: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify({ productIds: productIds }),
        success: function(res) {
          if (!res.data || !res.data.length) {
            productFn.scheduleAlsoLoveScrollIndicatorUpdate();
            return;
          }
          for (var i = 0; i < skcTitleList.length; i++) {
            var score = res.data[i];
            var target = $container.find('.ws-product-block[data-skc-title="' + skcTitleList[i] + '"]');
            if (target.length) {
              target.find('.reviews-star-box').html(renderCompact(score));
            }
          }
          productFn.scheduleAlsoLoveScrollIndicatorUpdate();
        },
        error: function() {
          for (var j = 0; j < list.length; j++) {
            var target = $container.find('.ws-product-block').eq(j);
            if (target.length) {
              target.find('.reviews-star-box').html(renderCompact(5));
            }
          }
          productFn.scheduleAlsoLoveScrollIndicatorUpdate();
        }
      });
    },
    insertBottomList() {
      alsoLoveDom.attr('style', 'display: flex;')
      WS.ui.collectionFn.getCollectionModule({
        dom: alsoLoveDom, 
      });
    },
    
    // Complete The Look：通过 Shopify `?sections=` 拉取服务端渲染的 HTML 并挂载到商详
    // - 插入后必须做一次布局计算（3/4 列样式），并触发曝光/懒加载
    getCompleteTheLookListHandle: function() {
      productFn.requestCompleteTheLookList();
    },

    // forceReload：为 true 时忽略已有列表并重新请求 section（如切换 merge 颜色/商品后）
    requestCompleteTheLookList: function() {
      var $wrap = $('#ws-product-complete-the-look');
      var sectionKey = 'westyle-complete-the-look-data';
      var sectionUrl = `${WS.site.baseUrl}${window.location.pathname}?sections=${sectionKey}`;

      WS.ajax({
        url: sectionUrl,
        type: 'GET',
        dataType: 'html',
        success: function(res) {
          var responseHTML = productFn.extractWestyleSectionHtml(res, sectionKey);
          $wrap = productFn.mountWestyleSectionShell(responseHTML, '#ws-product-complete-the-look', '#ws-product-complete-the-look-mount');
          $wrap.show();
          productFn.applyCompleteTheLookLayout();
          // Complete The Look 是异步挂载的，插入 DOM 后需要补一次 activity-wrapper 同步。
          productFn.renderProductCampaignMessage();
          productFn.renderCompleteLookCampaignMessage();
          productFn.renderCompleteLookFreeGiftMessage();
          // 动态插入新卡片后，需要重新触发曝光与懒加载初始化
          WS.ui.globalListExposureHandle && WS.ui.globalListExposureHandle();
          WS.ui.initImgLazyloadHandle && WS.ui.initImgLazyloadHandle();
        },
        error: function() {
          // 请求失败时隐藏模块，避免空容器占位
          $('#ws-product-complete-the-look').hide();
        },
        complete: function() {
          setTimeout(function() {
            $list = $wrap.find('.ws-complete-the-look-listbox .ws-featured-collection-product-list');
            if (!$list.length || !$list.find('.ws-product-block').length) {
              $wrap.hide();
              return;
            }
          }, 3000);
        }
      });
    },
    showPreview: function(idx) {
      if (!$('#prodcut-preview_dialog').length) {
        var { productJson } = WS.ui.getProductData(productId, productDataDom);
        var mediaList = productJson.media;
        var len = mediaList.length;
        var innerEl = '';
        for (var i = 0; i < len; i++) {
          innerEl += productFn.renderPreviewItem(mediaList[i], i, len);
        }
        $('body').append(previewDialog);
        $('#prodcut-preview_dialog').find('.product-preview_container').html(innerEl);
        $('#prodcut-preview_dialog').show();
        setTimeout(() => {
          previewSlider = new WS.Slider({
            container: ".product-preview_wrapper",
          });
          previewSlider.slideTo(idx, 0);
        }, 300)
      } else {
        $('#prodcut-preview_dialog').show();
        previewSlider.slideTo(idx, 0);
      }
    },
    renderPreviewItem: function(data, index, length) {
      var item = 
      `<div class="product-preview_item" data-id="${data.id}" data-index="${index}">
        <div class="product-preview_image_wrapper">
          <img class="product-preview_image"
            src="${data.preview_image.src.replace(".jpg", "_966x.jpg").replace(".png", "_966x.png")}"
            alt="${data.alt}"
          />
        </div>
        <div class="product-preview_index">${index + 1}/${length}</div>
      </div>`;
      return item
    },
    syncSlideSize: function() {
      var $slideBox = $('.slide-container-box');
      var domSize = $('.slide-container-wrapper .slide-item').length;
      var attrSize = parseInt($slideBox.attr('data-size'), 10);
      var slideSize = domSize || (isNaN(attrSize) ? 0 : attrSize);
      $slideBox.attr('data-size', slideSize);
      return slideSize;
    },
    initSliderIndex: function() {
      if (productFn.isDesktopView()) {
        $('.slide-container-box .slide-index').html('');
        return;
      }
      $('.slide-container-box .slide-index').html('');
      var slideSize = productFn.syncSlideSize();
      if (!slideSize) return;
      var indexItem = `<div class="slide-index-item"></div>`
      for (var i = 0; i < slideSize; i++) {
        $('.slide-index').append(indexItem);
      }
    },
    bindStickyBottomButton: function() {
      if (productFn.isDesktopView()) {
        return;
      }
      var $bottomWrapper = $('.product-detail_bottom-wrapper');
      var $btnWrapper = $bottomWrapper.find('.product-detail_btn-wrapper');
      if (!$bottomWrapper.length || !$btnWrapper.length) return;
      var bottomWrapperEl = $bottomWrapper[0];
      if (!bottomWrapperEl) return;

      var originTop = 0;
      var originHeight = 0;
      var ticking = false;

      function calcThreshold() {
        // 只在未吸底状态下记录一次原始位置，避免 position: fixed 影响计算
        if ($bottomWrapper.hasClass('fixed-bottom')) return;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        var rect = bottomWrapperEl.getBoundingClientRect();
        originTop = rect.top + scrollTop;
        originHeight = bottomWrapperEl.offsetHeight || 0;
      }

      function updateStickyState() {
        var winH = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!winH) return;

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        // 元素原始底部位置（基于文档流，已在 calcThreshold 中记录）
        var elementBottom = originTop + originHeight;

        // 仅当原始区域「整体在视口上方」，也就是完全滚出屏幕时才吸底，
        // 这样按钮还在屏幕里可见时不会提前固定，避免闪烁
        var shouldFixed = scrollTop >= elementBottom;
        // 吸底样式挂在外层 wrapper 上，配合
        // .product-detail_bottom-wrapper.fixed-bottom { position: fixed; bottom: 0; left: 0; }
        $bottomWrapper.toggleClass('fixed-bottom', shouldFixed);
        // 仅给按钮容器加安全区内边距，兼容 iPhone X 等机型
        $btnWrapper.toggleClass('fix-padding-bot', shouldFixed);
        // 订阅 FAB bottom 用 CSS var，吸底后抬高避免被挡（westyle.css）
        var docStyle = document.documentElement.style;
        if (!shouldFixed) {
          docStyle.removeProperty('--ws-product-atc-sticky-height');
        } else {
          requestAnimationFrame(function () {
            docStyle.setProperty('--ws-product-atc-sticky-height', (bottomWrapperEl.offsetHeight || 0) + 'px');
          });
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          updateStickyState();
          ticking = false;
        });
      }

      calcThreshold();
      updateStickyState();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function() {
        calcThreshold();
        updateStickyState();
      });
    }
  };

  function init() {
    productFn.bindStickyBottomButton();
    productFn.initSliderIndex();
    productFn.initSlide();
    productFn.bindEvent();
    productFn.renderProductCampaignMessage();
    productFn.renderCompleteLookCampaignMessage();
    productFn.renderCompleteLookFreeGiftMessage();
    // 购物车异步刷新后同步更新 PDP 文案档位。
    window.addEventListener('ws:cart-count-updated', function(event) {
      productFn.renderProductCampaignMessage();
      productFn.renderCompleteLookCampaignMessage();
      productFn.renderCompleteLookFreeGiftMessage(event && event.detail);
    });
    wsSanitizeProductDetailsRichText();
    // desc HTML：改 WS_PRODUCT_DETAILS_DESC_READ_MORE.expandAsHtml = true，或 initProductDetailsDescReadMore(true)
    productFn.initProductDetailsDescReadMore();
    productFn.fetchProductMetafieldsData();

    try {
      WS.ui.getProductData(productId, productDataDom);
      selectedColor = $('.color-item.selected').attr('data-product-id') || $('.product-sku-wrapper').attr('data-product-id');
      selectedSize = $('.size-item.selected').attr('data-value');
      WS.ui.selectedColor = ($('.product-page__color-item.selected').attr('data-value') || $('.color-selected-value').first().text() || '').trim();
      WS.ui.selectedSize = selectedSize || '';
      $('.size-selected-value').text(selectedSize);
      selectedSku = $('.size-item.selected').attr('data-variant-id');
      WS.ui.applySizeInventory('#product-page');
      var $selectedSizeItem = $('.product-page__size-item.selected').first();
      setAddToBagSoldOut($selectedSizeItem.length && $selectedSizeItem.hasClass('sold-out'));
      if ($selectedSizeItem.length && !$selectedSizeItem.hasClass('sold-out')) {
        renderProductSelectedSizeStockTip($selectedSizeItem);
      } else {
        renderProductUsWarehouseStockTip();
      }
    } catch (e) {}

    productFn.getAlsoLoveListHandle();
    productFn.getCompleteTheLookListHandle();
    productFn.applyCompleteTheLookLayout();
    setTimeout(function() {
      WS.ui.storeIsRegisteAd && WS.ui.storeIsRegisteAd();
      if (WS.ui.showRegisteModule()) {
        WS.ui.insertRegisteModuel && WS.ui.insertRegisteModuel('product');
      }

      WS.ui.initScrollToTop();
    }, 500);
  }
  

  init();

  WS.ui.reportInteractiveTime();
  
  WS.ui.asyncLoadUrls(window.WS_PRODUCT_LOAD_URLS);

  WS.ui.productFn = {
		alsoLikeScrollToHandle: productFn.alsoLikeScrollToHandle,
		reportProductInfo: productFn.reportProductInfo,
    renderSliderByMedia: productFn.renderSliderByMedia
	};
})();
